import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useAuth } from './context/AuthContext';
import Login from './components/Login';
import SoruKarti, { LatexText, onizlemeKes } from './components/SoruKarti';
import LgsKart, { OptikIsaret } from './components/LgsKart';
import LgsDersSecici from './components/LgsDersSecici';
import BaglamGrupKarti from './components/BaglamGrupKarti';
import KitapcikGorunum from './components/KitapcikGorunum';
import Istatistikler from './components/Istatistikler';
import Analiz from './components/Analiz';
import Basim from './components/Basim';
import Uretim from './components/Uretim';
import PaketInceleme from './components/PaketInceleme';
import DenemeInceleme from './components/DenemeInceleme';
import UzmanSeti from './components/UzmanSeti';
import LgsSeti from './components/LgsSeti';
import KonuDagilimi from './components/KonuDagilimi';
import BenzerlikRozeti from './components/BenzerlikRozeti';
import TestGorunum from './components/TestGorunum';
import Kullanicilar from './components/Kullanicilar';
import MusteriSiparisYonetimi from './components/MusteriSiparisYonetimi';
import SoruSatisi from './components/SoruSatisi';
import YayineviSecici from './components/YayineviSecici';
import { SuzgecSecimleri, Sayfalama, suzgecSinifi, SIRALAMALAR } from './components/ListeSuzgecleri';
import SatisEkleModal from './components/SatisEkleModal';
import { satisOzeti, satildiMi, satisRozetMetni, satisRozetBaslik, satisKilitSorusu, secimiSatisIcinAyir, cevapQcOzeti } from './lib/satis';
import PanelHeader from './components/PanelHeader';
// Ders registry + renk haritası tek doğruluk kaynağı (KonuDagilimi ile paylaşılır).
import { DERSLER, LGS_DERSLERI, dersRenk, dersLabel, dersCiftMufredatliMi, maarifKazanimMi, mebKazanimMi, kazanimEtiketi, kazanimSozleri, kartBasligi } from './lib/dersler';
// Bağlam rozeti rengi tek kaynaktan okunur (öğretmen 2026-08-13).
import { BAGLAM_ROZET_KUCUK } from './lib/baglamRozet';
// Puan -> zorluk seviyesi (ad + renk) tek kaynaktan (ogretmen karari 2026-08-31).
import { puanRenk, puanBaslik, ZORLUK_FILTRE_SECENEKLERI } from './lib/zorlukSeviye';
import DersMultiSelect from './components/ui/DersMultiSelect';

import { API, LGS_MODU } from './lib/ortam';
const SAYFA_LIMIT = 100;
// Gruplu görünüm "genel bakış" amaçlı: seçili tüm dersler tek ekranda konu-konu
// gruplansın diye yüksek limit (2026-07-17). Çoklu ders + 100-limit ENUM-ilk dersi
// doldurup diğerlerini gizliyordu. Hafif projeksiyon (id/konu/zorluk) → ~1500 satır
// sorun değil; çok büyük seçimler (ör. Tüm Dersler) yine sayfalanır.
const GRUP_LIMIT = 1500;
// Kitapçık görünümü (2026-10-31, kullanıcı isteği): web sayfası başına 10 soru — metin, şık ve
// şekil taşındığı için kart görünümünün 100'ü yerine; sonrası sayfalama.
const KITAPCIK_LIMIT = 10;
const aktifLimit = (mod) => (mod === 'grup' ? GRUP_LIMIT : mod === 'kitapcik' ? KITAPCIK_LIMIT : SAYFA_LIMIT);

const ZORLUKLAR = [
  { value: '', label: 'Tüm Zorluklar' },
  { value: 'kolay', label: 'Kolay' },
  { value: 'orta', label: 'Orta' },
  { value: 'zor', label: 'Zor' },
  { value: 'uzman', label: 'Uzman' },
];

// Sayfa geçiş düğmeleri tek tip; yalnız ▶ Üret birincil (2026-10-19, düzen).
const NAV_DUGME = 'px-2.5 py-1.5 rounded-md border border-gray-200 bg-white text-xs font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300';

const ZORLUK_SIRA = { kolay: 1, orta: 2, zor: 3, uzman: 4 };

// Yerel gün (YYYY-MM-DD), n gün önce — tarih süzgecinin hızlı düğmeleri.
const gunOnce = (n) => { const t = new Date(); t.setDate(t.getDate() - n); return t.toLocaleDateString('sv-SE'); };

// BAĞLAM TEMELLİ GRUP — liste kartlarını BİRLEŞTİR (öğretmen 2026-08-12:
// "bağlam soruları tek kartta gösterilsin"). Aynı `baglam_grubu`'na ait
// kayıtlar tek kartta toplanır; grup kartı listedeki İLK üyesinin yerinde
// durur (sıralama bozulmaz).
//
// Grubun yalnız BİR üyesi bu sayfadaysa (sayfalama grubu böldü) tekil karta
// düşer ve kendi "Bağlam <sıra>/<toplam>" rozetini taşır — böylece öğretmen
// sayfa sonunda kalan üyeyi de grubun parçası olarak görür.
export function baglamGrupla(liste) {
  const cikti = [];
  const yer = new Map();
  liste.forEach((s) => {
    const g = s.baglam_grubu;
    if (!g) { cikti.push(s); return; }
    if (!yer.has(g)) {
      yer.set(g, cikti.length);
      cikti.push({ __grup: true, key: g, uyeler: [s] });
      return;
    }
    cikti[yer.get(g)].uyeler.push(s);
  });
  return cikti.map((x) => {
    if (!x.__grup) return x;
    // SAYFADA OLMAYAN KARDEŞ (2026-09-21, öğretmen: "2 soru da puanlanmış
    // olmasına rağmen tek puan görünüyor"). Varsayılan "son işlem" sıralamasında
    // bir üyeye dokunan her yazma onu sayfa 1'e taşıyıp kardeşini geride
    // bırakıyor; grup bölününce kart tek puan basıyordu. Backend bölünmüş grubun
    // eksik üyelerinin ÖZETİNİ gönderir (`grup_eksik_uyeler`, lib/baglamEksik.js);
    // burada GÖLGE ÜYE'ye çevrilir: kimlik + puan + durum özetten, ortak alanlar
    // (ders/konu/kazanım/satış — bağlam grubu tek birimdir) sayfadaki üyeden.
    const kaynak = x.uyeler[0];
    const ozetler = (x.uyeler.find(u => Array.isArray(u.grup_eksik_uyeler)) || {}).grup_eksik_uyeler || [];
    const mevcut = new Set(x.uyeler.map(u => Number(u.public_no)));
    ozetler.forEach((o) => {
      if (mevcut.has(Number(o.public_no))) return;
      mevcut.add(Number(o.public_no));
      x.uyeler.push({
        ders: kaynak.ders, konu: kaynak.konu, alt_konu: kaynak.alt_konu,
        kazanim_kodu: kaynak.kazanim_kodu, mufredat_efektif: kaynak.mufredat_efektif,
        baglam_grubu: kaynak.baglam_grubu, grup_toplam: kaynak.grup_toplam,
        satis: kaynak.satis,
        ...o, __eksik: true,
      });
    });
    x.uyeler.sort((a, b) => (Number(a.grup_sira) || 0) - (Number(b.grup_sira) || 0));
    return x.uyeler.length === 1 ? x.uyeler[0] : x;
  });
}

// BAĞLAM TEMELLİ GRUP — detaydan ÇIKIŞ koşulu (öğretmen 2026-08-16: "bağlam
// temelli sorularda 2 soru da onaylandığı anda bu sorudan çıkıp soru havuzuna
// yönlendirme yapılmalıdır").
//
// Kullanıcı kararı 2026-08-16: çıkış YALNIZ tüm üyeler `onaylandi` olduğunda.
// Reddedilen üye varsa ekranda kalınır (öğretmen "← Geri Dön" ile çıkar).
//
// Kontrol DÖNEN ÜYE LİSTESİ üzerinden yapılır, `grup.toplam` üzerinden DEĞİL:
// parçalı grupta (grup_toplam=2 ama tek kayıt var) toplam beklenirse ekran
// hiçbir zaman kapanmaz. Parçalı grup uyarısını BaglamGrupKarti ayrıca basar.
export function grupHepsiOnayli(grup) {
  const uyeler = grup && Array.isArray(grup.sorular) ? grup.sorular : [];
  return uyeler.length > 0 && uyeler.every(u => u.durum === 'onaylandi');
}

// Son 1 saat icinde mi?
function yeniMi(tarih) {
  if (!tarih) return false;
  return (Date.now() - new Date(tarih).getTime()) < 3600000;
}

// KaTeX render'i .katex-html (her atom ayri span) + .katex-mathml (annotation)
// ikilisi uretir. Tarayici kopyalama her ikisini birlestirip "f\n(\n5\n)f(5)"
// gibi bozuk metin dokuyor. Asagidaki fonksiyon secimdeki .katex elementlerini
// annotation (TeX kaynak) metniyle $...$ sarmali olarak degistirip clipboard'a
// duz metin yaziyor. Boylece DB'deki formatla round-trip (kopyala -> yapistir ->
// yeniden render) ayni kalir.
function serializeForClipboard(node) {
  let out = '';
  for (const child of node.childNodes) {
    if (child.nodeType === Node.TEXT_NODE) {
      out += child.nodeValue;
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      const tag = child.nodeName;
      if (tag === 'BR') { out += '\n'; continue; }
      if (tag === 'SCRIPT' || tag === 'STYLE') continue;
      out += serializeForClipboard(child);
      if (/^(DIV|P|LI|TR|H[1-6])$/.test(tag)) out += '\n';
    }
  }
  return out;
}

function handleKatexCopy(e) {
  const sel = window.getSelection();
  if (!sel || sel.isCollapsed) return;
  const range = sel.getRangeAt(0);
  const fragment = range.cloneContents();
  // Sadece .katex icerip icermediginii kontrol et
  const hasKatex = fragment.querySelector ? fragment.querySelector('.katex') : null;
  if (!hasKatex) {
    // Normal metin — tarayici varsayilani dokunmadan devam etsin
    return;
  }
  const container = document.createElement('div');
  container.appendChild(fragment);

  // Her .katex'i annotation (TeX kaynak) ile degistir, uygun delimiter sar
  container.querySelectorAll('.katex').forEach(k => {
    const annot = k.querySelector('annotation[encoding="application/x-tex"]');
    const tex = annot ? annot.textContent : '';
    if (!tex) { k.remove(); return; }
    const isDisplay = k.closest('.katex-display') != null;
    const wrapped = isDisplay ? `$$${tex}$$` : `$${tex}$`;
    k.replaceWith(document.createTextNode(wrapped));
  });

  // Kalan mathml kirintilari varsa temizle
  container.querySelectorAll('.katex-mathml, math').forEach(n => n.remove());

  let text = serializeForClipboard(container);
  // Satir ici fazla bosluk + \n cevresindeki bosluklari sikistir
  text = text.replace(/[ \t]+/g, ' ').replace(/[ \t]*\n[ \t]*/g, '\n').replace(/\n{3,}/g, '\n\n').trim();

  e.clipboardData.setData('text/plain', text);
  e.preventDefault();
}

export default function App() {
  const { kullanici, yukleniyor: authYukleniyor, cikisYap, authFetch, rolYeterli, izinliDersler, dersGorebilir } = useAuth();

  const [sorular, setSorular] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [satilanGoster, setSatilanGoster] = useState(() => { try { return localStorage.getItem('yks_satilan_goster') === '1'; } catch { return false; } });
  const satilanToggle = () => setSatilanGoster(v => { try { localStorage.setItem('yks_satilan_goster', v ? '0' : '1'); } catch {} return !v; });
  // Baslik rozeti UC sayi basar (ogretmen istegi 2026-08-20): filtreye uyan tum
  // sorular / yayinevine verilenler dusulmus NET havuz / o net havuzdaki ONAYLI.
  // Ucu de ayni `GET /api/sorular` yanitindan gelir -> filtre degisince birlikte
  // guncellenir, ek istek gerekmez.
  const [netToplam, setNetToplam] = useState(0);
  const [netOnayli, setNetOnayli] = useState(0);
  // Baslik rozetinin Maarif/2018 satir kirilimi (2026-09-04, ogretmen istegi) —
  // ayni `GET /api/sorular` yanitindan gelir, ekstra istek gerekmez.
  const [toplamMaarif, setToplamMaarif] = useState(0);
  const [netToplamMaarif, setNetToplamMaarif] = useState(0);
  const [netOnayliMaarif, setNetOnayliMaarif] = useState(0);
  const [toplamMeb, setToplamMeb] = useState(0);
  const [netToplamMeb, setNetToplamMeb] = useState(0);
  const [netOnayliMeb, setNetOnayliMeb] = useState(0);
  // Backend `soru_yayinevi_kullanim` tablosunu goremezse false doner (deploy
  // sirasi toleransi) -> "net" bolumu gizlenir, rozet iki sayiya duser.
  const [yayineviAktif, setYayineviAktif] = useState(true);
  // Satilan kirilimi (2026-09-14, ogretmen istegi): baslikta toplam − satilan = net
  // ve onayliya etki gorunur. Ayni `GET /api/sorular` yanitindan gelir.
  const [satilanSayac, setSatilanSayac] = useState({});
  const [sayfa, setSayfa] = useState(1);
  // Çoklu ders seçimi (2026-07-17): [] = Tüm Dersler. Kazanım kaskadı + müfredat
  // butonu yalnız TEK ders seçiliyken görünür (tekDers türevi).
  const [dersler, setDersler] = useState([]);
  const [zorluk, setZorluk] = useState('');
  const [puanFiltre, setPuanFiltre] = useState('');
  // Liste sıralaması — 'grup' görünümünde backend'in kendi grup sırası geçerli.
  const [siralama, setSiralama] = useState('islem');
  const [pratikDurum, setPratikDurum] = useState('');
  // `?public_no=N` derin bağlantısı (P1a, 2026-08-13): benzerlik rozeti ve
  // raporlardaki panel linkleri bu parametreyle geliyor. Açılışta filtre barının
  // numara kutusuna yazılır — böylece link tıklanınca eş soru doğrudan süzülür.
  const [publicNoAra, setPublicNoAra] = useState(() => {
    try {
      const v = new URLSearchParams(window.location.search).get('public_no');
      // Rakam disi karakter ayiklanir: `?public_no=abc` ile acilan panel aksi
      // halde acilista 400 alirdi (backend 2026-08-31'den beri gecersiz degeri
      // sessizce yok saymiyor). Kutu icine yazarken de ayni kural uygulanir.
      return v ? String(v).replace(/[^0-9]/g, '') : '';
    } catch { return ''; }
  });
  const [kazanimKonu, setKazanimKonu] = useState('');
  const [kazanimDetay, setKazanimDetay] = useState('');
  const [kazanimHarita, setKazanimHarita] = useState(null);
  // Müfredat seçimi (yalnız matematik ailesi): '' = Hepsi, 'MEB_2018', 'Maarif_2024'
  const [mufredat, setMufredat] = useState('');
  // Süzgeç metinleri: Maarif seçiliyken "öğrenme çıktısı" (2026-10-09, kullanıcı kararı).
  const soz = kazanimSozleri(mufredat);
  // Ders özeti — müfredat butonu sayıları (Hepsi/2018/Maarif) için.
  const [dersOzeti, setDersOzeti] = useState({});      // { tyt_matematik: N, ... }
  const [maarifOzeti, setMaarifOzeti] = useState({});  // { tyt_matematik: a, ..., toplam: M }
  const [yukleniyor, setYukleniyor] = useState(false);
  const [seciliSoru, setSeciliSoru] = useState(null);
  // Bağlam temelli grup detayı (KURALLAR §19.3) — seçili soru bir gruba aitse
  // GET /api/sorular/:id/grup yanıtı burada durur, detay birleşik kart olarak açılır.
  const [grupDetay, setGrupDetay] = useState(null);
  const [gorunum, setGorunum] = useState('liste');
  // Detaydan çıkınca dönülecek görünüm (Uzman Seti sekmesinden açılan soru sekmeye döner).
  const [detayDonus, setDetayDonus] = useState('liste');
  const [testPartisi, setTestPartisi] = useState(null);
  const [seciliIds, setSeciliIds] = useState(new Set());
  const [topluMod, setTopluMod] = useState(false);
  // Satışa ekle modalı — toplu seçimin kararı (null = kapalı):
  // { nolar: uygun public_no[], elenenler: [{public_no, neden}], seciliSayisi }.
  const [satisModal, setSatisModal] = useState(null);
  // Satış Arşivi → Basım ön-seçimi (2026-09-14): { ids: uuid[], yayineviId, yayineviAd, donus: 'satis' } | null.
  // Doluyken Basım bu sorularla ve "Çözümler PDF’in sonunda" AÇIK başlar; Geri → Satış.
  // 2026-09-15: seçili satırların yayınevi de taşınır (Basım'da yeniden sorulmaz).
  const [basimOnSecim, setBasimOnSecim] = useState(null);
  // Basım "Satış Arşivi’nde gör" → Satış Arşivi hangi sekmeyle açılsın ('aktif' | 'teslim').
  const [satisBaslangicSekme, setSatisBaslangicSekme] = useState('aktif');

  // Yeni: Goruntuleme modu
  // LGS de kitapçıkla açılır (2026-10-31, kullanıcı: "alt bölümü de YKS gibi"); kart görünümü düğmeyle.
  const [listeModu, setListeModu] = useState('kitapcik'); // 'kitapcik' | 'duz' | 'grup'
  const [yeniFiltre, setYeniFiltre] = useState(false);
  // Bağlam temelli soru süzgeci (öğretmen 2026-08-13). '' | 'var' | 'yok'.
  // Koşul müfredat değil, `kaynak_detay.baglam_grubu` alanının varlığıdır —
  // rozetin koşuluyla birebir aynı (KURALLAR §19.3 md.8).
  const [baglamFiltre, setBaglamFiltre] = useState('');
  // Görsel süzgeci (2026-10-10): '' | 'var' (TikZ ya da SVG) | 'tikz' | 'svg' | 'yok'.
  const [gorselFiltre, setGorselFiltre] = useState('');
  // Satış süzgeci (2026-09-14, kullanıcı kararı: satılan soru listede görünür +
  // rozet). '' = Tümü | 'satilmamis' | 'satilan' → GET /api/sorular `satis`.
  const [satisFiltre, setSatisFiltre] = useState('');
  // Satılanlar seçiliyken alıcı yayınevi (2026-10-20, kullanıcı isteği) — yalnız admin+.
  const [satisYayinevi, setSatisYayinevi] = useState(null);
  // Cevap QC süzgeci (2026-09-15): '' = Tümü | 'uyusmazlik' | 'onayli' | 'yok'
  // → GET /api/sorular `cevap_qc` (denetim_izi CEVAP-QC + OGRETMEN-KOR).
  const [qcFiltre, setQcFiltre] = useState('');
  // Zorluk kör örneklemi (2026-09-25): '' | 'bekliyor' | 'verildi' → GET /api/sorular `kor_puan`.
  const [korPuanFiltre, setKorPuanFiltre] = useState('');
  // Komşu: disiplinler arası bağlamla üretilen sorular (2026-10-19, kullanıcı isteği).
  const [komsuFiltre, setKomsuFiltre] = useState('');
  // Metin + tarih araması (2026-10-20, LGS paneli): kutu yazıldıkça değil 400 ms durunca istek atar.
  const [metinGirdi, setMetinGirdi] = useState('');
  const [metinAra, setMetinAra] = useState('');
  const [tarihMin, setTarihMin] = useState('');
  const [tarihMax, setTarihMax] = useState('');
  useEffect(() => {
    const t = setTimeout(() => { const v = metinGirdi.trim(); setMetinAra((o) => { if (o !== v) setSayfa(1); return v; }); }, 400);
    return () => clearTimeout(t);
  }, [metinGirdi]);
  const [acikGruplar, setAcikGruplar] = useState(new Set());

  // WebSocket bildirimleri
  const [wsStatus, setWsStatus] = useState('baglaniyor');
  const [bildirimler, setBildirimler] = useState([]);

  // Tam olarak BİR ders seçiliyse o ders; aksi halde '' (kaskad/müfredat gizli).
  const tekDers = dersler.length === 1 ? dersler[0] : '';
  // Tıkla-filtrele scroll hedefi (KonuDagilimi rozet tıklaması filtre barına iner).
  const filtreBarRef = useRef(null);

  // Toast mesaji (2.5sn goruntulenir)
  const [toast, setToast] = useState(null);
  const toastGoster = (mesaj, tip = 'basari') => {
    setToast({ mesaj, tip });
    setTimeout(() => setToast(null), 2500);
  };

  // KaTeX icerigini kopyalarken clipboard'i $...$ sarmali duz metne cevir
  useEffect(() => {
    document.addEventListener('copy', handleKatexCopy);
    return () => document.removeEventListener('copy', handleKatexCopy);
  }, []);

  // Kazanım haritasını seçili ders + müfredata göre yükle.
  // Kaskad yalnız TEK ders seçiliyken görünür (2026-07-17) → harita da yalnız
  // o durumda çekilir; 0 veya 2+ derste temizlenir.
  useEffect(() => {
    if (!kullanici) return;
    if (dersler.length !== 1) { setKazanimHarita(null); return; }
    const params = new URLSearchParams();
    params.append('ders', dersler[0]);
    if (mufredat === 'Maarif_2024') params.append('mufredat', 'Maarif_2024');
    authFetch(`${API}/api/kazanim?${params.toString()}`)
      .then(r => r.json())
      .then(d => setKazanimHarita(d.konular || null))
      .catch(() => {});
  }, [kullanici, authFetch, dersler, mufredat]);

  // Ders özeti (müfredat butonu sayıları: Hepsi/2018/Maarif) — bir kez yüklenir.
  useEffect(() => {
    if (!kullanici) return;
    authFetch(`${API}/api/kazanim/ders-ozeti`)
      .then(r => r.json())
      .then(d => { setDersOzeti(d.sayilar || {}); setMaarifOzeti(d.maarif || {}); })
      .catch(() => {});
  }, [kullanici, authFetch, toplam]);

  useEffect(() => {
    if (!kullanici) return;
    const token = localStorage.getItem('yks_token');
    if (!token) return;
    const wsUrl = `${API.replace('http', 'ws')}/ws?token=${token}`;
    let ws;
    try {
      ws = new WebSocket(wsUrl);
      ws.onopen = () => setWsStatus('bagli');
      ws.onclose = () => setWsStatus('kapali');
      ws.onerror = () => setWsStatus('hata');
      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.tip === 'uretim' || data.tip === 'onay') {
            setBildirimler(prev => [data, ...prev].slice(0, 10));
          }
        } catch {}
      };
    } catch {}
    return () => { if (ws) ws.close(); };
  }, [kullanici]);

  const sorulariGetir = useCallback(async () => {
    if (!kullanici) return;
    setYukleniyor(true);
    try {
      const params = new URLSearchParams({ sayfa, limit: aktifLimit(listeModu) });
      // lgs.makembed.fun: liste yalnız sorular_lgs'ten (backend ?lgs=1; ders iznine göre süzülür)
      if (LGS_MODU) params.append('lgs', '1');
      // Çoklu ders: virgüllü liste (backend ANY ile süzer). Boş = tüm dersler.
      if (dersler.length) params.append('ders', dersler.join(','));
      // Müfredat süzgeci yalnız TEK ders seçili + o derste seçici GÖRÜNÜR ise
      // (iki müfredatlı) gönderilir — tablo seçimini backend yapar. Aksi halde
      // gizli seçici + aktif süzgeç = sebepsiz boş liste olurdu.
      if (mufredat && tekDers && dersCiftMufredatliMi(tekDers, dersOzeti, maarifOzeti)) params.append('mufredat', mufredat);
      if (zorluk) params.append('zorluk', zorluk);
      if (puanFiltre) params.append('puan', puanFiltre);
      if (pratikDurum) params.append('pratik_durum', pratikDurum);
      if (baglamFiltre) params.append('baglam', baglamFiltre);
      if (gorselFiltre) params.append('gorsel', gorselFiltre);
      if (satisFiltre) params.append('satis', satisFiltre);
      if (satisFiltre === 'satilan' && satisYayinevi) params.append('satis_yayinevi_id', String(satisYayinevi.id));
      if (qcFiltre) params.append('cevap_qc', qcFiltre);
      if (korPuanFiltre) params.append('kor_puan', korPuanFiltre);
      if (komsuFiltre) params.append('komsu', komsuFiltre);
      if (yeniFiltre) params.append('yeni', 'true');
      if (metinAra) params.append('q', metinAra);
      if (tarihMin) params.append('tarih_min', tarihMin);
      if (tarihMax) params.append('tarih_max', tarihMax);
      if (publicNoAra && publicNoAra.trim()) {
        params.append('public_no', publicNoAra.trim().replace(/^#/, ''));
      }
      const kazanimKodFiltre = kazanimDetay || kazanimKonu;
      if (kazanimKodFiltre) params.append('kazanim_kodu', kazanimKodFiltre);
      params.append('siralama', listeModu === 'grup' ? 'grup' : siralama);
      if (listeModu === 'kitapcik') params.append('gorunum', 'kitapcik');
      const r = await authFetch(`${API}/api/sorular?${params}`);
      const data = await r.json();
      setSorular(data.sorular || []);
      setToplam(data.toplam || 0);
      // Eski backend (alan yok) -> net = toplam; rozet sessizce bozulmaz.
      setNetToplam(Number.isFinite(data.net_toplam) ? data.net_toplam : (data.toplam || 0));
      setNetOnayli(Number.isFinite(data.net_onayli) ? data.net_onayli : 0);
      // Eski backend (alanlar yok) -> 0; baslikta ilgili satir bos gorunur, kirilmaz.
      setToplamMaarif(Number.isFinite(data.toplam_maarif) ? data.toplam_maarif : 0);
      setNetToplamMaarif(Number.isFinite(data.net_toplam_maarif) ? data.net_toplam_maarif : 0);
      setNetOnayliMaarif(Number.isFinite(data.net_onayli_maarif) ? data.net_onayli_maarif : 0);
      setToplamMeb(Number.isFinite(data.toplam_meb) ? data.toplam_meb : 0);
      setNetToplamMeb(Number.isFinite(data.net_toplam_meb) ? data.net_toplam_meb : 0);
      setNetOnayliMeb(Number.isFinite(data.net_onayli_meb) ? data.net_onayli_meb : 0);
      setYayineviAktif(data.yayinevi_dislama_aktif !== false);
      // Eski backend (alanlar yok) -> 0; satilan pili "0" gosterir, kirilmaz.
      const _satilan = (ek) => ({
        satilan: Number.isFinite(data['satilan' + ek]) ? data['satilan' + ek] : 0,
        satilanOnayli: Number.isFinite(data['satilan_onayli' + ek]) ? data['satilan_onayli' + ek] : 0,
        teslim: Number.isFinite(data['satilan_teslim' + ek]) ? data['satilan_teslim' + ek] : 0,
      });
      setSatilanSayac({ MEB_2018: _satilan('_meb'), Maarif_2024: _satilan('_maarif') });
    } catch (e) { console.error('Hata:', e); }
    setYukleniyor(false);
  }, [sayfa, dersler, tekDers, mufredat, maarifOzeti, zorluk, puanFiltre, siralama, pratikDurum, baglamFiltre, gorselFiltre, satisFiltre, satisYayinevi, qcFiltre, korPuanFiltre, komsuFiltre, yeniFiltre, metinAra, tarihMin, tarihMax, publicNoAra, kazanimKonu, kazanimDetay, listeModu, kullanici, authFetch]);

  useEffect(() => { sorulariGetir(); }, [sorulariGetir]);

  // Satış / Basım ekranında satış durumu değişebilir (satış, İPTAL, PDF teslimi).
  // Listeye dönünce kartlar TAZE çekilir. 2026-09-14 kullanıcı bildirimi: #2356
  // satılıp iptal edildi (DB'de aktif satış 0) ama liste yeniden yüklenmediği için
  // kart "💰 satıldı" rozetini taşımaya devam etti; "Satışa Ekle" de bu bayat
  // satırdan "zaten satıldı" deyip soruyu eledi.
  const oncekiGorunum = useRef(gorunum);
  useEffect(() => {
    const onceki = oncekiGorunum.current;
    oncekiGorunum.current = gorunum;
    if (gorunum === 'liste' && (onceki === 'satis' || onceki === 'basim')) sorulariGetir();
  }, [gorunum, sorulariGetir]);

  // Kazanım dropdown'unda gösterilecek sınıflar: derse göre daralt
  // (tyt_* → 9-10, ayt_* → 11-12, boş/Tüm Dersler → hepsi).
  const kazanimSiniflari = useMemo(() => {
    // Sosyal alt-dersleri (2026-07-17 bölme): genel TYT=9-10/AYT=11-12 varsayımı
    // uymaz (ör. TYT Tarih 9-11, AYT Mantık 11). Backend zaten alt-ders+sınav
    // filtreli döndürdüğü için sınıfları yüklü haritadan türet.
    const sosyalAlt = /(tarih|cografya|felsefe|din|mantik|psikoloji|sosyoloji)/.test(tekDers);
    if (sosyalAlt && Array.isArray(kazanimHarita) && kazanimHarita.length) {
      return [...new Set(kazanimHarita.map(k => k.sinif))].sort((a, b) => a - b);
    }
    if (tekDers.startsWith('lgs_')) return [8];
    if (tekDers.startsWith('tyt_')) return [9, 10];
    if (tekDers.startsWith('ayt_')) return [11, 12];
    return [9, 10, 11, 12];
  }, [tekDers, kazanimHarita]);

  // Gruplama hesapla
  const gruplar = useMemo(() => {
    if (listeModu !== 'grup') return null;
    const map = {};
    sorular.forEach(s => {
      const dersKey = s.ders || 'diger';
      // Maarif_2024'te `konu` OGRENME ALANI adidir ve tekrar eder — "Geometrik
      // Şekiller" dort ayri temada (MAT.9.3/10.1/11.2/12.2), "Nicelikler ve
      // Değişimler" de dort temada. Bu yuzden AYT geometri panelde tek baslik
      // goruluyordu (ogretmen geri bildirimi 2026-08-12). Maarif sorularinda
      // ayirt edici `alt_konu` varsa onunla grupla. MEB_2018 tarafinda alt_konu
      // serbest metin (5407 farkli deger) — orada konu grubu korunur.
      const konuKey = (maarifKazanimMi(s.kazanim_kodu, s.mufredat_efektif) && s.alt_konu)
        ? s.alt_konu
        : (s.konu || 'Genel');
      if (!map[dersKey]) map[dersKey] = {};
      if (!map[dersKey][konuKey]) map[dersKey][konuKey] = [];
      map[dersKey][konuKey].push(s);
    });
    // Konu icerisinde zorluk siralama
    for (const d of Object.keys(map)) {
      for (const k of Object.keys(map[d])) {
        map[d][k].sort((a, b) => (ZORLUK_SIRA[a.zorluk] || 5) - (ZORLUK_SIRA[b.zorluk] || 5));
      }
    }
    return map;
  }, [sorular, listeModu]);

  const grupToggle = (key) => {
    setAcikGruplar(prev => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  // Ilk yuklemede tum gruplari ac
  useEffect(() => {
    if (gruplar) {
      const keys = new Set();
      Object.keys(gruplar).forEach(d => {
        keys.add(d);
        Object.keys(gruplar[d]).forEach(k => keys.add(`${d}|${k}`));
      });
      setAcikGruplar(keys);
    }
  }, [gruplar]);

  const soruDetayGetir = async (id) => {
    if (topluMod) {
      setSeciliIds(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
      return;
    }
    const r = await authFetch(`${API}/api/sorular/${id}`);
    const soru = await r.json();
    setSeciliSoru(soru);
    setGrupDetay(null);
    setGorunum('detay');
    // Bağlam temelli grup (KURALLAR §19.3): kayıt bir gruba aitse üyeler çekilir
    // ve detay TEK BİRLEŞİK KART olarak açılır (ortak kök + görsel bir kez).
    if (soru && soru.kaynak_detay && soru.kaynak_detay.baglam_grubu) {
      await grupGetir(id);
    }
  };

  // Grup üyelerini çeker. Hata durumunda sessizce tekil moda düşer — grup kartı
  // bir GÖSTERİM katmanı, erişilemezse soru yine tek başına incelenebilmeli.
  const grupGetir = async (id) => {
    try {
      const g = await authFetch(`${API}/api/sorular/${id}/grup`);
      if (!g.ok) return null;
      const veri = await g.json();
      const gecerli = veri && Array.isArray(veri.sorular) && veri.sorular.length > 0;
      setGrupDetay(gecerli ? veri : null);
      return gecerli ? veri : null;
    } catch {
      setGrupDetay(null);
      return null;
    }
  };

  // Grup açıkken bir üye güncellendiğinde (puan/pratik/video) yalnız o üyeyi tazele.
  const grupUyeGuncelle = (id, yama) => {
    setGrupDetay(prev => prev ? {
      ...prev,
      sorular: prev.sorular.map(u => (u.id === id ? { ...u, ...yama } : u)),
    } : prev);
  };

  // SATILMIŞ SORU KİLİDİ (2026-09-14, kullanıcı kararı): satılmış sorunun içeriği
  // kilitli — /onayla, /puan, /pratik 409 `satilmis_soru_kilitli` döner. Öğretmen
  // BİLİNÇLİ onay verirse aynı istek `satis_override:true` ile yinelenir (backend
  // yalnız admin'de işler). Vazgeçilirse `vazgecildi:true` taşıyan yanıt döner;
  // çağıranın `!r.ok` dalı onu "değişiklik yapılmadı" uyarısına çevirir.
  const satisKilidiIleGonder = async (url, govde) => {
    const gonder = (g) => authFetch(url, { method: 'PATCH', body: JSON.stringify(g) });
    const r = await gonder(govde);
    if (r.status !== 409) return r;
    const d = await r.json().catch(() => ({}));
    const yanitKopyasi = { ok: false, status: 409, json: () => Promise.resolve(d) };
    if (d.red_nedeni !== 'satilmis_soru_kilitli') return yanitKopyasi;
    if (!window.confirm(satisKilitSorusu(d))) return { ...yanitKopyasi, vazgecildi: true };
    return gonder({ ...govde, satis_override: true });
  };
  const KILIT_VAZGECILDI = 'Değişiklik yapılmadı — satılmış soru kilitli.';

  const detaydanCik = () => { setGorunum(detayDonus); setDetayDonus('liste'); setSeciliSoru(null); setGrupDetay(null); };

  const soruOnayla = async (id, onay, yorum = '', puan = null, redNedeni = null) => {
    // 403 (ders yetkisi yok) / 404 / 500 sessizce yutulmamali — aksi halde ogretmen
    // puani verir, liste'ye doner ve "kaydoldu" sanir ama DB degismez (biyoloji puan
    // bug'inin sebep sinifi). Hata varsa listeye DONME, gorunur toast goster.
    const r = await satisKilidiIleGonder(`${API}/api/sorular/${id}/onayla`, { onay, yorum, puan, red_nedeni: redNedeni || null });
    if (!r.ok) {
      if (r.vazgecildi) { toastGoster(KILIT_VAZGECILDI, 'uyari'); return; }
      const d = await r.json().catch(() => ({}));
      toastGoster((onay ? 'Onaylanamadı: ' : 'Reddedilemedi: ') + (d.hata || r.status), 'hata');
      return;
    }
    // Bağlam temelli grupta onay KAYIT BAŞINADIR (§19.3 md.6): 1. soruyu onaylayan
    // öğretmen sayfadan atılmamalı, 2. soruyu da değerlendirebilmeli. Grup açıkken
    // listeye dönmek yerine grubu tazele.
    //
    // Öğretmen 2026-08-16: "2 soru da onaylandığı anda bu sorudan çıkıp soru havuzuna
    // yönlendirme yapılmalıdır." Eski kodda çıkış TEK koşula bağlıydı (`!taze` = grup
    // verisi çekilemedi); backend `/:id/grup` üyeleri `durum` filtresi olmadan
    // döndürdüğü için `taze` HER ZAMAN dolu geliyordu -> `!taze` asla true olmuyor ->
    // ekran detayda donuyordu. Çıkış koşulu artık üyelerin `durum`una bakar.
    if (grupDetay) {
      const taze = await grupGetir(id);
      sorulariGetir();
      const hepsiOnayli = grupHepsiOnayli(taze);
      if (!taze) {
        toastGoster(onay ? 'Soru onaylandı ✓' : 'Soru reddedildi ✗');
        detaydanCik();
      } else if (hepsiOnayli) {
        toastGoster(`Bağlam grubu tamamlandı ✓ — ${taze.sorular.length} soru onaylandı`);
        detaydanCik();
      } else {
        toastGoster(onay ? 'Soru onaylandı ✓ — grupta karar bekleyen soru var' : 'Soru reddedildi ✗');
      }
      return;
    }
    sorulariGetir(); detaydanCik();
  };

  const puanKaydet = async (id, puan) => {
    if (!puan) { toastGoster('Önce puan seçin (1-10).', 'uyari'); return; }
    const r = await satisKilidiIleGonder(`${API}/api/sorular/${id}/puan`, { puan });
    if (!r.ok && r.vazgecildi) { toastGoster(KILIT_VAZGECILDI, 'uyari'); return; }
    if (!r.ok) { const d = await r.json().catch(() => ({})); toastGoster('Puan kaydedilemedi: ' + (d.hata || r.status), 'hata'); return; }
    setSeciliSoru(prev => (prev && prev.id === id) ? { ...prev, zorluk_puan: puan } : prev);
    grupUyeGuncelle(id, { zorluk_puan: puan });
    toastGoster(`Puan kaydedildi: ${puan}/10`);
    sorulariGetir();
  };

  // Pratik çözüm onay/reddet (Sprint 3, 2026-05-15)
  // pratik_onayli: true = onayla, false = reddet, null = sıfırla
  const soruPratikOnay = async (id, pratik_onayli) => {
    const r = await satisKilidiIleGonder(`${API}/api/sorular/${id}/pratik`, { pratik_onayli });
    if (!r.ok) {
      if (r.vazgecildi) { toastGoster(KILIT_VAZGECILDI, 'uyari'); return; }
      const d = await r.json().catch(() => ({}));
      toastGoster('Pratik onay güncellenemedi: ' + (d.hata || r.status), 'hata');
      return;
    }
    setSeciliSoru(prev => (prev && prev.id === id) ? { ...prev, pratik_onayli } : prev);
    grupUyeGuncelle(id, { pratik_onayli });
    toastGoster(
      pratik_onayli === true ? 'Pratik çözüm onaylandı ✓'
      : pratik_onayli === false ? 'Pratik çözüm reddedildi ✗'
      : 'Pratik onay sıfırlandı'
    );
    sorulariGetir();
  };

  // Cozum videosu ogretmen onayi — pratik onay akisinin ikizi.
  // Panelden YALNIZ video_onayli degistirilebilir; video_url/durum uretim
  // hattinin (video_toplu_uret.py) tek kapisindan yazilir.
  const soruVideoOnay = async (id, video_onayli) => {
    const r = await authFetch(`${API}/api/sorular/${id}/video`, {
      method: 'PATCH',
      body: JSON.stringify({ video_onayli }),
    });
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      toastGoster('Video onayı güncellenemedi: ' + (d.hata || r.status), 'hata');
      return;
    }
    setSeciliSoru(prev => (prev && prev.id === id) ? { ...prev, video_onayli } : prev);
    grupUyeGuncelle(id, { video_onayli });
    toastGoster(
      video_onayli === true ? 'Çözüm videosu onaylandı ✓'
      : video_onayli === false ? 'Çözüm videosu reddedildi ✗'
      : 'Video onayı sıfırlandı'
    );
    sorulariGetir();
  };

  // KÖR ONAY (2026-09-15, cevap QC — kullanıcı kararı "kanıt + örneklemeli kör onay"):
  // öğretmenin anahtarı görmeden işaretlediği cevap denetim_izi'ne (OGRETMEN-KOR)
  // yazılır; İLK cevap korunur. Uyuşmazlık "Cevap QC: uyuşmazlık" süzgecinde görünür.
  const korCevap = async (soru, harf) => {
    const r = await authFetch(`${API}/api/sorular/by-public-no/${soru.public_no}/kor-cevap`, {
      method: 'POST',
      body: JSON.stringify({ harf }),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error('Kör cevap kaydedilemedi: ' + (d.hata || r.status));
    const kor_onay = { cevap: d.cevap, uyustu: d.uyustu, tarih: d.tarih };
    setSeciliSoru(prev => (prev && prev.id === soru.id) ? { ...prev, kor_onay, kor_ornek: false } : prev);
    grupUyeGuncelle(soru.id, { kor_onay, kor_ornek: false });
    toastGoster(d.uyustu ? 'Kör cevap anahtarla uyuştu ✓'
      : 'Kör cevap anahtardan farklı — uyuşmazlık kuyruğuna alındı', d.uyustu ? undefined : 'uyari');
    return d;
  };

  // ZORLUK KÖR PUANI (2026-09-25, kullanıcı kararı "yalnız ölçüm"): öğretmen ajanın puanını
  // görmeden puanlar; puan denetim_izi'ne yazılır, zorluk_puan DEĞİŞMEZ. Yanıt artık gizli
  // olmayan alanları (ajan puanı + yorum) taşır → kart normal görünüme döner, kıyas görünür.
  const korPuanVer = async (soru, puan) => {
    const r = await authFetch(`${API}/api/sorular/by-public-no/${soru.public_no}/kor-puan`, {
      method: 'POST',
      body: JSON.stringify({ puan }),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error('Kör puan kaydedilemedi: ' + (d.mesaj || d.hata || r.status));
    const guncel = { ...(d.alanlar || {}), kor_puan: d.kor_puan, kor_puan_ornek: false };
    setSeciliSoru(prev => (prev && prev.id === soru.id) ? { ...prev, ...guncel } : prev);
    grupUyeGuncelle(soru.id, guncel);
    toastGoster(`Kör puan kaydedildi: ${d.kor_puan.puan}/10`);
    return d.kor_puan;
  };

  // CEVAP QC KANITI (2026-09-15, kullanıcı isteği "kanıt ayrıntısını panelde göster"): kart
  // "Kanıt" düğmesiyle tek soru için istenir (liste yolu ağır JSON taşımaz). Kör onay
  // örneğinde sunucu 409 döner (kanıt anahtarı ele verir).
  const cevapQcKanit = async (soru) => {
    const r = await authFetch(`${API}/api/sorular/by-public-no/${soru.public_no}/cevap-qc-kanit`);
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.hata || `Kanıt alınamadı (HTTP ${r.status})`);
    return d;
  };

  // CEVAP QC İSTEĞİ (2026-09-15, kullanıcı isteği "panele QC'ye gönder düğmesini ekle"): istek
  // sıraya yazılır, rtn-bakim-cevap-qc routine'ine "şimdi çalıştır" niyeti bırakılır (açıksa).
  // Yalnız admin'e verilir (her istek token harcar); iptal yalnız bekleyen istekte.
  const cevapQcIstek = async (soru, { iptal = false } = {}) => {
    const r = await authFetch(`${API}/api/sorular/by-public-no/${soru.public_no}/cevap-qc-istek`, {
      method: iptal ? 'DELETE' : 'POST',
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.hata || `QC isteği gönderilemedi (HTTP ${r.status})`);
    const istek = iptal ? null : (d.istek || null);
    setSeciliSoru(prev => (prev && prev.id === soru.id) ? { ...prev, cevap_qc_istek: istek } : prev);
    grupUyeGuncelle(soru.id, { cevap_qc_istek: istek });
    return d;
  };

  // Toplu "Satışa Ekle" (2026-09-14, kullanıcı: "Satış için seçilecek sorular
  // onaylanmış olmalıdır"). İKİNCİ bildirim aynı gün: "13 soru seçili ama 1 soru için
  // fiyat hesaplıyor." Kök neden: seçim sayfa/filtre değişince KORUNUR ama burada
  // yalnız ekrandaki sayfa (`sorular`) süzülüyordu — öteki seçimler SESSİZCE düşüyor,
  // uygunsuzlar birkaç saniyelik bir bildirimle eleniyordu. Artık seçilen HER soru
  // sunucudan taze çekilir (durum + satış bilgisi), karar lib/satis
  // `secimiSatisIcinAyir` ile verilir, elenenler MODALIN İÇİNDE nedenleriyle durur.
  // Son söz yine backend'de (POST /api/satis hep-ya-hiç 409).
  const topluSatisaEkle = async () => {
    const ids = [...seciliIds];
    if (ids.length === 0) return;
    const satirlar = [];
    try {
      for (let i = 0; i < ids.length; i += 500) { // /batch tavanı 500
        const r = await authFetch(`${API}/api/sorular/batch`, {
          method: 'POST', body: JSON.stringify({ ids: ids.slice(i, i + 500) }),
        });
        const d = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(d.hata || `HTTP ${r.status}`);
        satirlar.push(...(d.sorular || []));
      }
    } catch (e) {
      toastGoster(`Seçili sorular okunamadı: ${e.message}`, 'hata');
      return;
    }
    const { uygun, elenen } = secimiSatisIcinAyir(satirlar, ids);
    // Cevap QC (2026-09-15, KAPI C): uygunlar içinde kör denetimle uyuşmayanlar UYARILIR (elenmez).
    const qcUyusmazlik = cevapQcOzeti(satirlar, uygun).uyusmazlik;
    setSatisModal({ nolar: uygun, elenenler: elenen, seciliSayisi: ids.length, qcUyusmazlik });
  };

  const yenilereTikla = () => {
    setYeniFiltre(true); setDersler([]); setZorluk(''); setSayfa(1);
    setBildirimler([]);
  };

  // Tüm filtreleri sıfırla (boş-sonuç ekranındaki buton için).
  const filtreleriSifirla = () => {
    setDersler([]); setZorluk(''); setPuanFiltre(''); setPratikDurum('');
    setPublicNoAra(''); setKazanimKonu(''); setKazanimDetay(''); setMufredat('');
    setSatisFiltre('');
    setSatisYayinevi(null);
    setQcFiltre('');
    setKorPuanFiltre('');
    setKomsuFiltre('');
    setBaglamFiltre('');
    setGorselFiltre('');
    setMetinGirdi(''); setMetinAra(''); setTarihMin(''); setTarihMax('');
    setYeniFiltre(false); setSayfa(1);
  };

  // Ortak süzgeç kutuları (components/ListeSuzgecleri.js) — YKS ve LGS listesi aynı state'i kullanır.
  const suzgecDegerleri = { puan: puanFiltre, qc: qcFiltre, kor: korPuanFiltre, gorsel: gorselFiltre, baglam: baglamFiltre, komsu: komsuFiltre, pratik: pratikDurum };
  const suzgecDegis = (ad, v) => {
    ({ puan: setPuanFiltre, qc: setQcFiltre, kor: setKorPuanFiltre, gorsel: setGorselFiltre, baglam: setBaglamFiltre, komsu: setKomsuFiltre, pratik: setPratikDurum })[ad](v);
    setSayfa(1);
  };

  // Ders seçimi değişimi (multiselect'ten): kazanım/müfredat bağımlılıkları resetlenir.
  const dersDegistir = (yeni) => {
    setDersler(yeni);
    setKazanimKonu(''); setKazanimDetay('');
    // Müfredat seçici görünmeyecekse süzgeci de bırakma (gizli-filtre tuzağı).
    if (yeni.length !== 1 || !dersCiftMufredatliMi(yeni[0], dersOzeti, maarifOzeti)) setMufredat('');
    setSayfa(1);
  };

  // Tıkla-filtrele (2026-07-17): KonuDagilimi kazanım ağacındaki soru rozetine
  // tıklanınca alttaki liste o ders(ler) + kazanıma filtrelenir. Matematik ailesi
  // 2 ders değeri geçer (tyt_matematik+tyt_geometri) → kaskad gizli, kazanım
  // chip'i görünür; diğerleri tek ders → kaskad ön-seçili açılır.
  // 2026-09-03: ağaç artık hangi müfredattan okunduğunu da bildiriyor. Müfredat
  // toggle'ı yalnız GÖRÜNDÜĞÜ derste (iki müfredatlı) kurulur — tek müfredatlı
  // derste gizli bir süzgeç bırakmamak için boşaltılır; liste zaten kazanım
  // koduyla doğru havuza iner (MEB "9.3" ile Maarif "MAT.9.5" ayrı kodlar).
  // 2026-10-21: `satis` geldiyse (Satılan düğmesi olan rol) satış süzgeci de kurulur —
  // satılan gizliyken rozetteki sayı satılmamışları sayar, liste de aynı sayıyı göstersin.
  const kazanimdanFiltrele = useCallback(({ dersDegerleri, konuKod, kod, mufredat: agacMufredat, satis }) => {
    if (satis !== undefined) setSatisFiltre(satis);
    const yeniDersler = dersDegerleri || [];
    setDersler(yeniDersler);
    const tek = yeniDersler.length === 1 ? yeniDersler[0] : null;
    setMufredat(
      agacMufredat && tek && dersCiftMufredatliMi(tek, dersOzeti, maarifOzeti) ? agacMufredat : ''
    );
    setKazanimKonu(konuKod || '');
    setKazanimDetay(kod && kod !== konuKod ? kod : '');
    setPublicNoAra(''); setYeniFiltre(false); setSayfa(1);
    setTimeout(() => filtreBarRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
  }, [dersOzeti, maarifOzeti]);

  if (authYukleniyor) return <div className="min-h-screen bg-gray-100 flex items-center justify-center text-gray-500">Yükleniyor...</div>;
  if (!kullanici) return <Login />;

  const toplamSayfa = Math.ceil(toplam / aktifLimit(listeModu));

  // Sayfa degistir: sinirla + listenin basina don
  const sayfaGit = (n) => {
    const hedef = Math.min(Math.max(1, Number(n) || 1), toplamSayfa);
    if (hedef === sayfa) return;
    setSayfa(hedef);
    setTimeout(() => filtreBarRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
  };

  // Grup kartı tıklaması: normal modda birleşik detay açılır, toplu modda
  // grubun TÜM üyeleri birlikte seçilir/bırakılır (grup atomik birimdir).
  const grupKartTikla = (uyeler) => {
    if (topluMod) {
      setSeciliIds(prev => {
        const n = new Set(prev);
        const hepsiSecili = uyeler.every(u => n.has(u.id));
        uyeler.forEach(u => (hepsiSecili ? n.delete(u.id) : n.add(u.id)));
        return n;
      });
      return;
    }
    soruDetayGetir(uyeler[0].id);
  };

  const renderGrupKart = (grup) => {
    const uyeler = grup.uyeler;
    // Ortak/meta alanlar (ders, konu, kazanım, tarih, ÖSYM skoru) sayfadaki
    // GERÇEK satırdan okunur: gölge üye (`__eksik`, sayfada olmayan kardeşin
    // özeti) yalnız kimlik + puan + durum taşır.
    const ilk = uyeler.find(u => !u.__eksik) || uyeler[0];
    const toplam = Number(ilk.grup_toplam) || uyeler.length;
    const secili = uyeler.every(u => seciliIds.has(u.id));
    const yeni = uyeler.some(u => yeniMi(u.olusturulma_zamani));
    const tekDurum = uyeler.every(u => u.durum === ilk.durum);
    const puanlar = uyeler.map(u => u.zorluk_puan);
    const puanVar = puanlar.some(p => p != null);
    return (
      <div key={grup.key} onClick={() => grupKartTikla(uyeler)}
        className={`bg-white rounded-xl p-3 cursor-pointer shadow-sm border-2 transition-all hover:shadow-md hover:-translate-y-0.5 relative ${secili ? 'border-blue-600 bg-blue-50' : 'border-indigo-200 hover:border-indigo-400'} ${yeni ? 'ring-2 ring-yellow-400' : ''}`}>
        {yeni && <span className="absolute -top-2 -right-2 bg-yellow-400 text-yellow-900 text-[9px] font-bold px-1.5 py-0.5 rounded-full animate-pulse">YENİ</span>}
        {topluMod && <div className="text-lg mb-1 text-blue-600">{secili ? '☑' : '☐'}</div>}
        <div className="flex items-center justify-between gap-1 mb-1.5">
          <span className="text-white px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide truncate min-w-0" style={{backgroundColor: dersRenk(ilk.ders)}}>{dersLabel(ilk.ders)}</span>
          {puanVar
            ? <span className="flex gap-1 shrink-0">
                {puanlar.map((p, i) => (
                  <span key={i} className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${p != null ? 'text-white' : 'border border-gray-300 text-gray-400 bg-white'}`}
                        style={p != null ? {backgroundColor: puanRenk(p)} : undefined}
                        title={`${i + 1}. soru — ${puanBaslik(p)}`}>{p != null ? p : '—'}</span>
                ))}
              </span>
            : <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold border border-gray-300 text-gray-400 bg-white shrink-0">Puan yok</span>
          }
        </div>
        <div className="text-[13px] font-semibold text-gray-800 mb-1.5 line-clamp-2"
             title={kartBasligi(ilk)}>
          {uyeler.map(u => (
            <span key={u.id} className="inline-block text-white px-1.5 py-0.5 rounded text-[10px] font-bold mr-1 align-middle" style={{backgroundColor: '#111827'}}>#{u.public_no}</span>
          ))}
          {kartBasligi(ilk)}
        </div>
        {ilk.kazanim_adi && (
          <div className="text-[11px] leading-snug text-gray-600 mb-1.5 line-clamp-2" title={`${ilk.kazanim_kodu} ${ilk.kazanim_adi}`}>
            <span className="font-semibold text-gray-500">{kazanimEtiketi(ilk)}:</span> {ilk.kazanim_adi}
          </div>
        )}
        <div className="mb-1.5 flex gap-1 flex-wrap">
          {tekDurum
            ? <span className="text-white px-1.5 py-0.5 rounded text-[9px] font-semibold" style={{backgroundColor: durumRenk(ilk.durum)}}>{durumEtiket(ilk.durum)}</span>
            : uyeler.map((u, i) => (
                <span key={u.id} className="text-white px-1.5 py-0.5 rounded text-[9px] font-semibold" style={{backgroundColor: durumRenk(u.durum)}} title={`${i + 1}. soru`}>
                  {i + 1}: {durumEtiket(u.durum)}
                </span>
              ))
          }
          {maarifKazanimMi(ilk.kazanim_kodu, ilk.mufredat_efektif) && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-emerald-100 text-emerald-800 border border-emerald-300" title="Maarif 2024 — 2028+ YKS">
              Maarif 24
            </span>
          )}
          {mebKazanimMi(ilk.kazanim_kodu, ilk.mufredat_efektif) && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-amber-100 text-amber-800 border border-amber-300" title="MEB 2018 — 2026-27 YKS">
              MEB 18
            </span>
          )}
          <span className={BAGLAM_ROZET_KUCUK}
                title={`Bağlam temelli soru grubu — ortak kök altında ${toplam} bağımsız soru`}>
            🔗 Bağlam · {toplam} soru
          </span>
          {uyeler.some(u => satildiMi(u.satis)) && (() => {
            const satilan = uyeler.filter(u => satildiMi(u.satis));
            return (
              <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-emerald-600 text-white truncate max-w-[140px]"
                    title={satilan.map(u => `#${u.public_no}: ${satisRozetBaslik(u.satis)}`).join('\n')}>
                {satilan.length === uyeler.length ? satisRozetMetni(satilan[0].satis) : `💰 ${satilan.length}/${uyeler.length} satıldı`}
              </span>
            );
          })()}
        </div>
        <div className="flex justify-between items-center text-[10px] text-gray-400 pt-1.5 border-t border-gray-50">
          <span>{(() => { const d = new Date(ilk.son_islem_zamani || ilk.guncelleme_zamani || ilk.olusturulma_zamani); const pad = n => String(n).padStart(2,'0'); return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`; })()}</span>
          <span>ÖSYM: {ilk.osym_uslup_skoru ? parseFloat(ilk.osym_uslup_skoru).toFixed(2) : '—'}</span>
        </div>
      </div>
    );
  };

  // KİTAPÇIK ROZETLERİ (2026-10-31): kart görünümündeki rozetlerin tek satırlık hali —
  // ders · puan · #numara · durum · müfredat · bağlam · benzerlik · satış · YENİ.
  const ROZET = 'px-1.5 py-0.5 rounded text-[10px] font-semibold';
  const mufredatRozeti = (s) => (
    <>
      {maarifKazanimMi(s.kazanim_kodu, s.mufredat_efektif) && <span className={`${ROZET} bg-emerald-100 text-emerald-800 border border-emerald-300`}>Maarif 24</span>}
      {mebKazanimMi(s.kazanim_kodu, s.mufredat_efektif) && <span className={`${ROZET} bg-amber-100 text-amber-800 border border-amber-300`}>MEB 18</span>}
    </>
  );
  const kitapRozetleri = (s) => (
    <div className="flex flex-wrap items-center gap-1 font-sans" title={kartBasligi(s)}>
      <span className={`${ROZET} text-white uppercase`} style={{ backgroundColor: dersRenk(s.ders) }}>{dersLabel(s.ders)}</span>
      {s.public_no != null && <span className={`${ROZET} text-white font-bold`} style={{ backgroundColor: '#111827' }}>#{s.public_no}</span>}
      {s.zorluk_puan != null
        ? <span className={`${ROZET} text-white`} title={puanBaslik(s.zorluk_puan)} style={{ backgroundColor: puanRenk(s.zorluk_puan) }}>Puan {s.zorluk_puan}/10</span>
        : <span className={`${ROZET} border border-gray-300 text-gray-400 bg-white`}>Puan yok</span>}
      <span className={`${ROZET} text-white`} style={{ backgroundColor: durumRenk(s.durum) }}>{durumEtiket(s.durum)}</span>
      {mufredatRozeti(s)}
      {s.baglam_grubu && <span className={BAGLAM_ROZET_KUCUK}>🔗 Bağlam {Number(s.grup_sira) || '?'}/{Number(s.grup_toplam) || '?'}</span>}
      <BenzerlikRozeti soru={s} kompakt />
      {satildiMi(s.satis) && <span className={`${ROZET} bg-emerald-600 text-white`} title={satisRozetBaslik(s.satis)}>{satisRozetMetni(s.satis)}</span>}
      {yeniMi(s.olusturulma_zamani) && <span className={`${ROZET} bg-yellow-400 text-yellow-900`}>YENİ</span>}
      <span className="text-[10px] text-gray-500 truncate max-w-full">{kartBasligi(s)}</span>
    </div>
  );
  // LGS kitapçık rozet satırı (2026-10-31): LgsKart'ın sade dili — renkli kutu yok, nokta + metin.
  // Grup verilirse üyelerin numaraları ve puanları sırayla basılır.
  const LGS_DURUM = { onaylandi: ['Onaylandı', '#2F7D5B'], onay_bekliyor: ['Onay bekliyor', '#B7791F'], reddedildi: ['Reddedildi', '#B42318'] };
  const lgsKitapRozetleri = (s, uyeler = null) => {
    const liste = uyeler || [s];
    const [dAd, dRenk] = LGS_DURUM[s.durum] || [durumEtiket(s.durum), '#6B7079'];
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 font-lexend text-[11px] text-lgs-soluk" title={kartBasligi(s)}>
        <span className="font-semibold tabular-nums text-lgs-murekkep">{liste.map((u) => `#${u.public_no}`).join(' · ')}</span>
        {liste.map((u) => (
          <span key={`p${u.public_no}`} className="inline-flex items-center gap-1" title={puanBaslik(u.zorluk_puan)}>
            <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{ backgroundColor: u.zorluk_puan != null ? puanRenk(u.zorluk_puan) : '#C9CED6' }} />
            {u.zorluk_puan != null ? `Puan ${u.zorluk_puan}` : 'Puansız'}
          </span>
        ))}
        <span className="inline-flex items-center gap-1"><span aria-hidden="true" className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: dRenk }} />{dAd}</span>
        <span className="inline-flex items-center gap-1 font-medium text-lgs-murekkep">
          <span aria-hidden="true" className="h-2 w-2 rounded-sm" style={{ backgroundColor: dersRenk(s.ders) }} />{dersLabel(s.ders).replace(/^LGS\s+/, '')}
        </span>
        {uyeler && <span className={BAGLAM_ROZET_KUCUK}>Bağlam · {Number(s.grup_toplam) || uyeler.length} soru</span>}
        <BenzerlikRozeti soru={s} kompakt />
        {liste.some((u) => yeniMi(u.olusturulma_zamani)) && <span className="text-lgs-optik">yeni</span>}
        {s.kazanim_kodu && <span className="w-full truncate" title={`${s.kazanim_kodu} ${s.kazanim_adi || ''}`}>{s.kazanim_kodu}{s.kazanim_adi ? ` ${s.kazanim_adi}` : ''}</span>}
      </div>
    );
  };
  const kitapGrupRozetleri = (uyeler) => {
    const ilk = uyeler.find(u => !u.__eksik) || uyeler[0];
    const toplamUye = Number(ilk.grup_toplam) || uyeler.length;
    const satilan = uyeler.filter(u => satildiMi(u.satis));
    return (
      <div className="flex flex-wrap items-center gap-1 font-sans" title={kartBasligi(ilk)}>
        <span className={`${ROZET} text-white uppercase`} style={{ backgroundColor: dersRenk(ilk.ders) }}>{dersLabel(ilk.ders)}</span>
        {uyeler.map(u => <span key={u.public_no} className={`${ROZET} text-white font-bold`} style={{ backgroundColor: '#111827' }}>#{u.public_no}</span>)}
        {uyeler.map((u, i) => (
          <span key={`p${u.public_no}`} className={`${ROZET} ${u.zorluk_puan != null ? 'text-white' : 'border border-gray-300 text-gray-400 bg-white'}`}
            style={u.zorluk_puan != null ? { backgroundColor: puanRenk(u.zorluk_puan) } : undefined}
            title={`${i + 1}. soru — ${puanBaslik(u.zorluk_puan)}`}>{u.zorluk_puan != null ? u.zorluk_puan : '—'}</span>
        ))}
        {uyeler.every(u => u.durum === ilk.durum)
          ? <span className={`${ROZET} text-white`} style={{ backgroundColor: durumRenk(ilk.durum) }}>{durumEtiket(ilk.durum)}</span>
          : uyeler.map((u, i) => <span key={`d${u.public_no}`} className={`${ROZET} text-white`} style={{ backgroundColor: durumRenk(u.durum) }}>{i + 1}: {durumEtiket(u.durum)}</span>)}
        {mufredatRozeti(ilk)}
        <span className={BAGLAM_ROZET_KUCUK}>🔗 Bağlam · {toplamUye} soru</span>
        {satilan.length > 0 && <span className={`${ROZET} bg-emerald-600 text-white`}>{satilan.length === uyeler.length ? satisRozetMetni(satilan[0].satis) : `💰 ${satilan.length}/${uyeler.length} satıldı`}</span>}
        {uyeler.some(u => yeniMi(u.olusturulma_zamani)) && <span className={`${ROZET} bg-yellow-400 text-yellow-900`}>YENİ</span>}
        <span className="text-[10px] text-gray-500 truncate max-w-full">{kartBasligi(ilk)}</span>
      </div>
    );
  };

  // Soru karti renderla (grup girdisi gelirse birlesik karta yonlendirir)
  const renderKart = (s) => {
    if (s.__grup) return renderGrupKart(s);
    const secili = seciliIds.has(s.id);
    const yeni = yeniMi(s.olusturulma_zamani);
    return (
      <div key={s.id} onClick={() => soruDetayGetir(s.id)}
        className={`bg-white rounded-xl p-3 cursor-pointer shadow-sm border transition-all hover:shadow-md hover:-translate-y-0.5 relative ${secili ? 'border-2 border-blue-600 bg-blue-50' : 'border-gray-100 hover:border-blue-200'} ${yeni ? 'ring-2 ring-yellow-400' : ''}`}>
        {yeni && <span className="absolute -top-2 -right-2 bg-yellow-400 text-yellow-900 text-[9px] font-bold px-1.5 py-0.5 rounded-full animate-pulse">YENİ</span>}
        {topluMod && <div className="text-lg mb-1 text-blue-600">{secili ? '☑' : '☐'}</div>}
        <div className="flex items-center justify-between gap-1 mb-1.5">
          <span className="text-white px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide truncate min-w-0" style={{backgroundColor: dersRenk(s.ders)}}>{dersLabel(s.ders)}</span>
          {s.zorluk_puan != null
            ? <span className="text-white px-1.5 py-0.5 rounded text-[10px] font-semibold shrink-0" title={puanBaslik(s.zorluk_puan)} style={{backgroundColor: puanRenk(s.zorluk_puan)}}>Puan {s.zorluk_puan}/10</span>
            : <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold border border-gray-300 text-gray-400 bg-white shrink-0">Puan yok</span>
          }
        </div>
        {/* Kart basligi: Maarif'te `konu` OGRENME ALANI adidir ve tekrar eder
            ("Geometrik Şekiller" dort temada) → ayirt edici `alt_konu` varsa o
            gosterilir; ogrenme alani title'da (hover) kalir. MEB_2018'de eskisi
            gibi `konu`. Ogretmen geri bildirimi 2026-08-12. */}
        <div className="text-[13px] font-semibold text-gray-800 mb-1.5 line-clamp-2"
             title={kartBasligi(s)}>
          {s.public_no != null && (
            <span className="inline-block text-white px-1.5 py-0.5 rounded text-[10px] font-bold mr-1.5 align-middle" style={{backgroundColor: '#111827'}}>#{s.public_no}</span>
          )}
          {kartBasligi(s)}
        </div>
        {s.kazanim_adi && (
          <div className="text-[11px] leading-snug text-gray-600 mb-1.5 line-clamp-2" title={`${s.kazanim_kodu} ${s.kazanim_adi}`}>
            <span className="font-semibold text-gray-500">{kazanimEtiketi(s)}:</span> {s.kazanim_adi}
          </div>
        )}
        {/* LGS kartı (2026-10-20): soru kökünün ilk satırları — yalnız LGS liste yanıtı `onizleme` taşır. */}
        {s.onizleme && (
          <div className="text-[11px] leading-snug text-gray-700 mb-1.5 line-clamp-3 bg-gray-50 rounded px-1.5 py-1">
            <LatexText>{onizlemeKes(s.onizleme)}</LatexText>
          </div>
        )}
        <div className="mb-1.5 flex gap-1 flex-wrap">
          <span className="text-white px-1.5 py-0.5 rounded text-[9px] font-semibold" style={{backgroundColor: durumRenk(s.durum)}}>{durumEtiket(s.durum)}</span>
          {s.dogru_cevap && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-gray-800 text-white" title="Doğru cevap">Cevap {s.dogru_cevap}</span>
          )}
          {maarifKazanimMi(s.kazanim_kodu, s.mufredat_efektif) && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-emerald-100 text-emerald-800 border border-emerald-300" title={String(s.ders || '').startsWith('lgs_') ? 'Maarif 2024 — 2028+ LGS' : 'Maarif 2024 — 2028+ YKS'}>
              Maarif 24
            </span>
          )}
          {mebKazanimMi(s.kazanim_kodu, s.mufredat_efektif) && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-amber-100 text-amber-800 border border-amber-300" title="MEB 2018 — 2026-27 YKS">
              MEB 18
            </span>
          )}
          {/* BAĞLAM TEMELLİ GRUP ROZETİ (KURALLAR §19.3, öğretmen 2026-08-12 #19851):
              iki bağımsız soru ortak bir kök altında toplanır; rozet hem grubu işaret
              eder hem GRUPTAKİ SORU SAYISINI yazar ("her bir soruda kaç adet soru
              olduğu belirtilecek"). Koşul müfredat değil, alanın varlığıdır. */}
          {s.baglam_grubu && (
            <span className={BAGLAM_ROZET_KUCUK}
                  title={`Bağlam temelli soru grubu — ortak kök altında ${Number(s.grup_toplam) || '?'} soru (bu ${Number(s.grup_sira) || '?'}. soru)`}>
              🔗 Bağlam {Number(s.grup_sira) || '?'}/{Number(s.grup_toplam) || '?'}
            </span>
          )}
          {/* BENZERLIK ROZETI (P1a, benzeşim denetimi 2026-08-13): korpusta >= 0.90
              kosinüs eşi olan sorular listede de işaretlenir; rozete tıklamak karta
              değil eş soruya gider (bileşen içinde stopPropagation). */}
          <BenzerlikRozeti soru={s} kompakt />
          {/* SATIŞ ROZETİ (2026-09-14): satılan soru listede kalır, işaretlenir. */}
          {satildiMi(s.satis) && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-emerald-600 text-white truncate max-w-[140px]"
                  title={satisRozetBaslik(s.satis)}>
              {satisRozetMetni(s.satis)}
            </span>
          )}
        </div>
        <div className="flex justify-between items-center text-[10px] text-gray-400 pt-1.5 border-t border-gray-50">
          <span>{(() => { const d = new Date(s.son_islem_zamani || s.guncelleme_zamani || s.olusturulma_zamani); const pad = n => String(n).padStart(2,'0'); return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`; })()}</span>
          {!String(s.ders || '').startsWith('lgs_') && <span>ÖSYM: {s.osym_uslup_skoru ? parseFloat(s.osym_uslup_skoru).toFixed(2) : '—'}</span>}
        </div>
      </div>
    );
  };

  // lgs.makembed.fun (lib/ortam.js): ayrı platform görünümü — LGS ana listesi (YKS kartları), detay,
  // super_admin'e LGS Seti + Basım. Bütün YKS hesapları girer; liste ders iznine göre (2026-10-20 kullanıcı kararı).
  // ponytail: YKS liste efektleri bu kipte de bir kez çalışır (zararsız fazladan istek); yük olursa LGS_MODU ile atlanır.
  if (LGS_MODU) {
    // "OPTİK FORM" tasarımı (2026-10-20, kullanıcı onayı): kâğıt zemin, kurşun kalem yazı, vurgu optik form
    // mürekkebi (lgs.optik) yalnız seçili durumda. Arayüz Lexend; soru detayı ve Basım kitapçık yazısında (Arial).
    const alan = (aktif) => `h-8 rounded-md border px-2 text-[13px] ${aktif
      ? 'border-lgs-optik bg-lgs-optikacik text-lgs-murekkep' : 'border-lgs-cizgi bg-white text-lgs-soluk hover:border-[#BFC5CE] hover:text-lgs-murekkep'}`;
    const sekme = (aktif) => `-mb-px border-b-2 px-3 py-2.5 text-[14px] transition-colors ${aktif
      ? 'border-lgs-optik font-medium text-lgs-murekkep' : 'border-transparent text-lgs-soluk hover:text-lgs-murekkep'}`;
    const listedeMi = gorunum === 'liste' || (gorunum === 'detay' && detayDonus === 'liste');
    const suzgecVar = dersler.length > 0 || kazanimKonu || kazanimDetay || publicNoAra || metinGirdi || tarihMin || tarihMax
      || Object.values(suzgecDegerleri).some(Boolean);
    return (
      <div className="min-h-screen bg-lgs-kagit text-lgs-murekkep">
        {toast && (
          <div role="status" className={`fixed top-5 right-5 z-[60] rounded-lg px-5 py-3 font-lexend text-sm font-medium text-white shadow-lg ${toast.tip === 'hata' ? 'bg-red-700' : toast.tip === 'uyari' ? 'bg-amber-600' : 'bg-lgs-onay'}`}>
            {toast.mesaj}
          </div>
        )}
        <header className="sticky top-0 z-30 border-b border-lgs-cizgi bg-lgs-kagit/95 font-lexend backdrop-blur">
          <div className="mx-auto flex max-w-[1400px] flex-wrap items-end gap-x-8 gap-y-1 px-5 pt-3">
            <div className="flex items-center gap-3 pb-2.5">
              <OptikIsaret dogru="C" boyut="logo" etiket={false} />
              <div className="leading-tight">
                <div className="whitespace-nowrap text-[17px] font-semibold">LGS Soru Paneli</div>
                <div className="whitespace-nowrap text-[12px] text-lgs-soluk">Maarif programı, 8. sınıf</div>
              </div>
            </div>
            {/* SORU SAYAÇLARI (2026-10-20, kullanıcı isteği "YKS'deki gibi"): aynı GET /api/sorular yanıtı, aktif
                süzgeç geçerli. LGS satışa girmediği için satılan/net yok (hep 0 / toplamla aynı); yerine onay bekleyen. */}
            <div data-testid="lgs-sayac" className="mb-2.5 inline-flex items-center overflow-hidden rounded-md border border-lgs-cizgi bg-white text-[13px] tabular-nums">
              <span className="px-3 py-1.5" title="Süzgece uyan bütün sorular (reddedilenler hariç)">
                <span className="font-semibold">{Number(toplam).toLocaleString('tr-TR')}</span> toplam
              </span>
              <span className="border-l border-lgs-cizgi px-3 py-1.5 text-lgs-soluk" title="Henüz onaylanmamış sorular">
                <span className="font-semibold text-[#B7791F]">{Math.max(0, toplam - netOnayli).toLocaleString('tr-TR')}</span> onay bekleyen
              </span>
              <span className="border-l border-lgs-cizgi bg-[#EEF6F1] px-3 py-1.5 text-lgs-onay" title="Öğretmenin onayladığı sorular">
                <span className="font-semibold">{Number(netOnayli).toLocaleString('tr-TR')}</span> onaylı
              </span>
            </div>
            <nav className="flex items-end" aria-label="Sayfalar">
              <button type="button" onClick={() => setGorunum('liste')} aria-current={listedeMi ? 'page' : undefined} className={sekme(listedeMi)}>
                Sorular
              </button>
              {rolYeterli('super_admin') && (
                <button type="button" onClick={() => setGorunum('lgsSet')} aria-current={gorunum === 'lgsSet' ? 'page' : undefined}
                  className={sekme(gorunum === 'lgsSet' || (gorunum === 'detay' && detayDonus === 'lgsSet'))} title="Kazanım kapsamı ve numara listesi">LGS Seti</button>
              )}
              {rolYeterli('super_admin') && (
                <button type="button" onClick={() => { setBasimOnSecim(null); setGorunum('basim'); }} aria-current={gorunum === 'basim' ? 'page' : undefined}
                  className={sekme(gorunum === 'basim')} title="Konu testi ve LGS oturum kitapçıkları">Basım</button>
              )}
            </nav>
            <div className="ml-auto flex items-center gap-2 pb-2.5 text-[13px]">
              <span className="hidden text-lgs-soluk sm:inline">{kullanici.ad}</span>
              <button type="button" onClick={cikisYap} className="rounded-md border border-transparent px-2.5 py-1.5 text-lgs-soluk hover:border-lgs-cizgi hover:bg-white hover:text-lgs-murekkep">Çıkış yap</button>
            </div>
          </div>
        </header>

        <main className="mx-auto max-w-[1400px] px-5 pb-12 pt-5">
        {gorunum === 'detay' && seciliSoru ? (
          <div className="font-serif">
            <SoruKarti soru={seciliSoru} onOnayla={soruOnayla} onPuanKaydet={puanKaydet} onPratikOnayla={soruPratikOnay} onVideoOnayla={soruVideoOnay} onKorCevap={korCevap} onKorPuan={korPuanVer} onCevapQcKanit={cevapQcKanit} onGeri={detaydanCik} />
          </div>
        ) : gorunum === 'liste' ? (
          // LGS ana listesi: backend ?lgs=1 ile yalnız sorular_lgs, kullanıcının ders iznine göre (auth.lgsGenislet).
          <div className="font-lexend">
            {/* DERS SEÇİCİ (2026-10-31): YKS ders seçicisinin LGS hâli — oturum bölümleri, onaylı/bekleyen çubuğu. */}
            <LgsDersSecici apiUrl={API} authFetch={authFetch} secili={dersler.length === 1 ? dersler[0] : ''}
              onSec={(k) => dersDegistir(k ? [k] : [])} gorebilir={dersGorebilir} yenile={`${toplam}-${netOnayli}`} />
            <section aria-label="Süzgeçler" className="mb-5 rounded-lg border border-lgs-cizgi bg-white">
              {/* Üst satır: kapsam (ders → konu → öğrenme çıktısı), numara, metin, tarih, sıra. */}
              <div className="flex flex-wrap items-center gap-2 px-3 py-2.5">
                <select aria-label="Ders" value={dersler[0] || ''} onChange={(e) => dersDegistir(e.target.value ? [e.target.value] : [])} className={alan(dersler.length)}>
                  <option value="">Bütün dersler</option>
                  {LGS_DERSLERI.filter((d) => dersGorebilir(d.value)).map((d) => <option key={d.value} value={d.value}>{d.label.replace(/^LGS\s+/, '')}</option>)}
                </select>
                {tekDers && Array.isArray(kazanimHarita) && kazanimHarita.length > 0 && (
                  <select aria-label="Konu" value={kazanimKonu} onChange={(e) => { setKazanimKonu(e.target.value); setKazanimDetay(''); setSayfa(1); }}
                    className={`${alan(kazanimKonu)} max-w-[220px]`}>
                    <option value="">Bütün konular</option>
                    {kazanimHarita.map((t) => <option key={t.kod} value={t.kod}>{t.kod} {t.ad}</option>)}
                  </select>
                )}
                {tekDers && kazanimKonu && Array.isArray(kazanimHarita) && (() => {
                  const sk = kazanimHarita.find((k) => k.kod === kazanimKonu);
                  if (!sk) return null;
                  return (
                    <select aria-label="Öğrenme çıktısı" value={kazanimDetay} onChange={(e) => { setKazanimDetay(e.target.value); setSayfa(1); }}
                      className={`${alan(kazanimDetay)} max-w-[260px]`}>
                      <option value="">Bütün öğrenme çıktıları</option>
                      {(sk.alt_konular || []).map((ak) => (
                        <optgroup key={ak.kod} label={`${ak.kod} ${ak.ad}`}>
                          <option value={ak.kod}>{ak.kod} tümü</option>
                          {(ak.kazanimlar || []).map((kaz) => <option key={kaz.kod} value={kaz.kod}>{kaz.kod} {String(kaz.ad || '').slice(0, 45)}</option>)}
                        </optgroup>
                      ))}
                    </select>
                  );
                })()}
                <input type="text" inputMode="numeric" value={publicNoAra} aria-label="Soru numarası" placeholder="Soru no"
                  onChange={(e) => { setPublicNoAra(e.target.value.replace(/[^0-9]/g, '')); setSayfa(1); }}
                  className={`${alan(publicNoAra)} w-24 tabular-nums`} />
                <input type="search" value={metinGirdi} onChange={(e) => setMetinGirdi(e.target.value)} maxLength={200}
                  aria-label="Soru metninde ara" placeholder="Soru metninde ara" className={`${alan(metinAra)} w-56`} />
                <div className="flex items-center gap-1.5 text-[13px] text-lgs-soluk" role="group" aria-label="Üretim tarihi">
                  <input type="date" value={tarihMin} max={tarihMax || undefined} onChange={(e) => { setTarihMin(e.target.value); setSayfa(1); }}
                    aria-label="Başlangıç tarihi" className={alan(tarihMin)} />
                  <span aria-hidden="true">–</span>
                  <input type="date" value={tarihMax} min={tarihMin || undefined} onChange={(e) => { setTarihMax(e.target.value); setSayfa(1); }}
                    aria-label="Bitiş tarihi" className={alan(tarihMax)} />
                  {[['Bugün', 0], ['7 gün', 6], ['30 gün', 29]].map(([l, g]) => (
                    <button key={l} type="button" onClick={() => { setTarihMin(gunOnce(g)); setTarihMax(gunOnce(0)); setSayfa(1); }}
                      className="rounded-md px-2 py-1 hover:bg-lgs-kagit hover:text-lgs-murekkep">{l}</button>
                  ))}
                </div>
                <div className="ml-auto flex items-center gap-2">
                  <div className="inline-flex h-8 overflow-hidden rounded-md border border-lgs-cizgi bg-white text-[13px]" role="group" aria-label="Görünüm">
                    {[['kitapcik', 'Kitapçık'], ['duz', 'Kartlar']].map(([v, l]) => (
                      <button key={v} type="button" aria-pressed={listeModu === v} onClick={() => { setListeModu(v); setSayfa(1); }}
                        className={`px-2.5 ${listeModu === v ? 'bg-lgs-optikacik font-medium text-lgs-optik' : 'text-lgs-soluk hover:text-lgs-murekkep'}`}>{l}</button>
                    ))}
                  </div>
                  <select aria-label="Sıralama" value={siralama} onChange={(e) => { setSiralama(e.target.value); setSayfa(1); }} className={alan(false)}>
                    {SIRALAMALAR.map((o) => <option key={o.value} value={o.value}>{o.label.replace(/^\S+\s/, '')}</option>)}
                  </select>
                  {rolYeterli('super_admin') && (
                    <button type="button" aria-pressed={topluMod} onClick={() => { setTopluMod((v) => !v); setSeciliIds(new Set()); }}
                      title="Kartlara dokunarak basım için soru seçin"
                      className={`h-8 rounded-md border px-3 text-[13px] ${topluMod ? 'border-lgs-murekkep bg-lgs-murekkep text-white' : 'border-lgs-cizgi bg-white hover:border-[#BFC5CE]'}`}>
                      {topluMod ? 'Seçimi kapat' : 'Basım için seç'}
                    </button>
                  )}
                </div>
              </div>
              {/* Alt satır: YKS ile ortak süzgeçler, LGS'de tek tip. */}
              <div className="flex flex-wrap items-center gap-2 border-t border-lgs-cizgi px-3 py-2.5">
                <SuzgecSecimleri degerler={suzgecDegerleri} onDegis={suzgecDegis} sinif={alan} />
                {suzgecVar && (
                  <button type="button" onClick={filtreleriSifirla} className="ml-auto rounded-md px-2 py-1 text-[13px] text-lgs-soluk hover:bg-lgs-kagit hover:text-lgs-murekkep">Süzgeçleri temizle</button>
                )}
              </div>
            </section>

            {/* SEÇİM ÇUBUĞU = BASIM LİSTESİ (YKS ile aynı ilke: hiçbir sorunun durumu değişmez). */}
            {topluMod && (
              <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-lgs-cizgi bg-white px-4 py-2.5 text-[14px]">
                <span>{seciliIds.size ? `${seciliIds.size} soru seçildi` : 'Basıma almak istediğiniz kartlara dokunun'}</span>
                {seciliIds.size > 0 && (
                  <>
                    <button type="button" onClick={() => { setBasimOnSecim({ ids: [...seciliIds], yayineviId: null, yayineviAd: '', donus: 'liste' }); setGorunum('basim'); }}
                      className="rounded-md bg-lgs-optik px-3 py-1.5 text-[13px] font-medium text-white hover:bg-[#A92A4D]">Basım listesine al</button>
                    <button type="button" onClick={() => setSeciliIds(new Set())}
                      className="rounded-md px-2 py-1.5 text-[13px] text-lgs-soluk hover:text-lgs-murekkep">Seçimi boşalt</button>
                  </>
                )}
              </div>
            )}

            {yukleniyor ? <SkeletonGrid /> : sorular.length === 0 ? (
              <div className="rounded-lg border border-dashed border-[#C9CED6] bg-white px-6 py-12 text-center">
                <p className="text-[15px]">Bu süzgeçlere uyan soru yok.</p>
                {suzgecVar && (
                  <button type="button" onClick={filtreleriSifirla} className="mt-3 rounded-md border border-lgs-cizgi px-3 py-1.5 text-[13px] hover:border-lgs-murekkep">Süzgeçleri temizle</button>
                )}
              </div>
            ) : listeModu === 'kitapcik' ? (
              // KİTAPÇIK (2026-10-31): YKS ile aynı dizgi (soru + 4 şık, iki sütun), optik form teması.
              <KitapcikGorunum ogeler={baglamGrupla(sorular)} ilkNo={(sayfa - 1) * KITAPCIK_LIMIT + 1} tema="lgs"
                baslikAdi={(d) => (d.length === 1 ? dersLabel(d[0]).replace(/^LGS\s+/, '') : 'LGS')}
                onSoruTikla={(s) => soruDetayGetir(s.id)} onGrupTikla={grupKartTikla}
                rozetler={lgsKitapRozetleri} grupRozetleri={(uyeler) => lgsKitapRozetleri(uyeler.find((u) => !u.__eksik) || uyeler[0], uyeler)}
                seciliIds={seciliIds} topluMod={topluMod} />
            ) : (
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
                {baglamGrupla(sorular).map((s) => (s.__grup ? renderGrupKart(s) : (
                  <LgsKart key={s.id} s={s} secili={seciliIds.has(s.id)} topluMod={topluMod} yeni={yeniMi(s.olusturulma_zamani)} onAc={soruDetayGetir} />
                )))}
              </div>
            )}
            <Sayfalama sayfa={sayfa} toplamSayfa={toplamSayfa} sayfaGit={sayfaGit} renk="optik" />
          </div>
        ) : !rolYeterli('super_admin') ? (
          <p className="font-lexend text-lgs-soluk">Bu bölüm yalnız süperadmine açıktır.</p>
        ) : gorunum === 'basim' ? (
          // Sekmeden boş açılır (Konu Testi / LGS oturumları) ya da listeden / LGS Seti'nden seçilen sorularla.
          <div className="font-serif">
            <Basim key={basimOnSecim ? basimOnSecim.ids.join(',') : 'bos'} apiUrl={API} authFetch={authFetch}
              baslangicSeciliIds={basimOnSecim ? basimOnSecim.ids : []} varsayilanCozumAyri
              baslangicYayineviId={null} baslangicYayineviAd="" onSatisArsivineGit={() => {}}
              onGeri={() => { const d = (basimOnSecim && basimOnSecim.donus) || 'liste'; setBasimOnSecim(null); setSeciliIds(new Set()); setTopluMod(false); setGorunum(d); }} />
          </div>
        ) : (
          <div className="font-lexend">
            <LgsSeti apiUrl={API} authFetch={authFetch} onGeri={() => setGorunum('liste')}
              onBasimaGonder={(ids) => { setBasimOnSecim({ ids, yayineviId: null, yayineviAd: '', donus: 'lgsSet' }); setGorunum('basim'); }}
              onSoruSec={async (id) => { const r = await authFetch(`${API}/api/sorular/${id}`); if (!r.ok) { toastGoster('Soru açılamadı: ' + r.status, 'hata'); return; } const so = await r.json(); setSeciliSoru(so); setGrupDetay(null); setDetayDonus('lgsSet'); setGorunum('detay'); }} />
          </div>
        )}
        </main>
      </div>
    );
  }

  return (
    <div className="font-serif max-w-[1400px] mx-auto p-5 bg-gray-50 min-h-screen">
      {/* TOAST */}
      {toast && (
        // z-[60]: satış modalının (z-50) perdesi toplu "Satışa Ekle" uyarısını örtmesin.
        <div className={`fixed top-5 right-5 z-[60] px-5 py-3 rounded-lg shadow-lg text-white font-semibold text-sm transition-opacity ${
          toast.tip === 'hata' ? 'bg-red-600' : toast.tip === 'uyari' ? 'bg-yellow-500' : 'bg-green-600'
        }`}>
          {toast.tip === 'hata' ? '✗ ' : toast.tip === 'uyari' ? '⚠ ' : '✓ '}{toast.mesaj}
        </div>
      )}

      {/* HEADER */}
      {/* <header className="sticky top-0 z-30 -mx-5 px-5 mb-6 py-3 bg-gray-50/90 backdrop-blur border-b border-gray-200 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <h1 className="text-xl sm:text-2xl font-bold text-blue-700 flex items-center gap-2">
            <span aria-hidden="true">📐</span> YKS Soru İnceleme Paneli
          </h1>
          SAYAC ROZETI — Toplam / Net / Onayli (2026-08-20). Segment gorunumu
              filtre cubugundaki mufredat toggle'iyla ayni dil. Ucu de filtreye
              duyarli: sorulariGetir her filtre degisiminde uctur birden ceker.
          <span className="inline-flex items-center rounded-full overflow-hidden text-sm font-semibold tabular-nums shadow-sm">
            <span className="bg-blue-600 text-white px-3 py-1" title="Filtreye uyan tüm sorular (reddedilenler hariç)">
              {Number(toplam).toLocaleString('tr-TR')}<span className="ml-1 text-xs font-normal opacity-75">toplam</span>
            </span>
            {yayineviAktif && (
              <span className="bg-blue-500 text-white px-3 py-1 border-l border-blue-400/60"
                title={`Yayınevine verilenler düşülmüş net havuz — ${Number(toplam - netToplam).toLocaleString('tr-TR')} soru düşüldü`}>
                {Number(netToplam).toLocaleString('tr-TR')}<span className="ml-1 text-xs font-normal opacity-75">net</span>
              </span>
            )}
            <span className="bg-emerald-600 text-white px-3 py-1" title="Net havuzdaki onaylı sorular">
              {Number(netOnayli).toLocaleString('tr-TR')}<span className="ml-1 text-xs font-normal opacity-80">onaylı</span>
            </span>
          </span>
        </div>
        <div className="flex items-center gap-2.5">
          <span className="flex items-center gap-1.5 text-xs text-gray-500" title={`WebSocket: ${wsStatus}`}>
            <span className={`w-2 h-2 rounded-full ${wsStatus === 'bagli' ? 'bg-green-500' : wsStatus === 'kapali' ? 'bg-red-500' : 'bg-yellow-500 animate-pulse'}`}></span>
            <span className="hidden sm:inline">{wsStatus === 'bagli' ? 'Bağlı' : wsStatus === 'kapali' ? 'Bağlantı yok' : 'Bağlanıyor'}</span>
          </span>
          {bildirimler.length > 0 && (
            <button onClick={yenilereTikla} className="bg-yellow-400 text-yellow-900 px-2.5 py-0.5 rounded-full text-xs font-bold animate-pulse hover:bg-yellow-300" title="Yeni soruları göster">
              {bildirimler.length} yeni
            </button>
          )}
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-gray-600 bg-white border border-gray-200 rounded-full pl-1 pr-2.5 py-0.5">
            <span className="w-5 h-5 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-[10px] font-bold uppercase">{(kullanici.ad || '?').slice(0, 1)}</span>
            {kullanici.ad} <span className="text-gray-400">({kullanici.rol})</span>
          </span>
          <button onClick={cikisYap} className="px-3 py-1.5 text-xs border border-red-300 text-red-600 rounded-lg hover:bg-red-50">Çıkış</button>
        </div>
      </header> */}
      <PanelHeader
        sayaclar={{
          MEB_2018: { toplam: toplamMeb, net: netToplamMeb, onayli: netOnayliMeb, ...satilanSayac.MEB_2018 },
          Maarif_2024: { toplam: toplamMaarif, net: netToplamMaarif, onayli: netOnayliMaarif, ...satilanSayac.Maarif_2024 },
        }}
        yayineviAktif={yayineviAktif && satilanGoster} satilanGoster={satilanGoster} onSatilanToggle={kullanici.rol === 'super_admin' ? satilanToggle : null} wsStatus={wsStatus} bildirimler={bildirimler} kullanici={kullanici} onYeniSorular={yenilereTikla} onCikis={cikisYap}
      />

      {gorunum === 'liste' ? (
        <>
          {/* KONU DAGILIMI */}
          <KonuDagilimi apiUrl={API} onKazanimFiltrele={kazanimdanFiltrele}
            satilanModu={kullanici.rol === 'super_admin' && yayineviAktif ? (satilanGoster ? 'goster' : 'gizle') : null} />

          {/* FİLTRE ÇUBUĞU (2026-09-29, düzen; 2026-10-19 sadeleşti): iki satırlı tek
              kart. Üst satır = kapsam (ders → müfredat → kazanım, soru no) + görünüm
              (sıralama, Gruplu/Liste, Seç) · sağda sayfa geçişleri (tek tip, yalnız
              ▶ Üret birincil). Alt satır = süzgeçler, anlam gruplarıyla: değerlendirme
              (puan, QC, kör puan) | içerik (görsel, bağlam, komşu, pratik) | satış;
              varsayılandan farklı olan kendi renginde yanar. */}
          <div ref={filtreBarRef} className="mb-4 scroll-mt-16 rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-wrap items-center gap-2 px-3 py-2">
            <div className="flex flex-wrap gap-1.5 items-center">
              <DersMultiSelect secili={dersler} onChange={dersDegistir} izinliDersler={izinliDersler} />

              {/* Müfredat seçici yalnız ders GERÇEKTEN iki müfredat da içeriyorsa
                  (sosyal tek-müfredatlı → gizli; bkz dersCiftMufredatliMi). */}
              {tekDers && dersCiftMufredatliMi(tekDers, dersOzeti, maarifOzeti) && (() => {
                // Seçili ders için müfredat dağılımı (Hepsi/2018/Maarif sayıları).
                const mSayi = maarifOzeti[tekDers] || 0;
                const hepsi = dersOzeti[tekDers] || 0;
                const meb = Math.max(0, hepsi - mSayi);
                const sayim = { '': hepsi, 'MEB_2018': meb, 'Maarif_2024': mSayi };
                return (
                  <div className="flex border border-violet-300 rounded overflow-hidden" title="Müfredat: bu ders hem 2018 (MEB) hem Maarif (2028+) sorularını içerir">
                    {[{ v: '', l: 'Hepsi' }, { v: 'MEB_2018', l: '2018' }, { v: 'Maarif_2024', l: 'Maarif' }].map(m => (
                      <button key={m.v || 'hepsi'} onClick={() => { setMufredat(m.v); setKazanimKonu(''); setKazanimDetay(''); setSayfa(1); }}
                        className={`px-2 py-1.5 text-xs ${mufredat === m.v
                          ? (m.v === 'Maarif_2024' ? 'bg-violet-600 text-white' : 'bg-blue-600 text-white')
                          : 'bg-white text-gray-600 hover:bg-gray-50'}`}>
                        {m.l}<span className="ml-1 opacity-70 font-semibold">{sayim[m.v]}</span>
                      </button>
                    ))}
                  </div>
                );
              })()}

              {/* Kazanım kaskadı yalnız TEK ders seçiliyken (kodlar ders-özel). */}
              {tekDers && (
              <select value={kazanimKonu} onChange={e => { setKazanimKonu(e.target.value); setKazanimDetay(''); setSayfa(1); }}
                className="px-2 py-1.5 rounded border border-gray-300 text-xs bg-white max-w-[160px]" title={`${soz.Ad} konusu`} aria-label={`${soz.Ad} konusu`}>
                <option value="">Tüm {soz.Adlar}</option>
                {kazanimHarita && kazanimSiniflari.map(sinif => {
                  const kl = kazanimHarita.filter(k => k.sinif === sinif);
                  return kl.length ? <optgroup key={sinif} label={`${sinif}. Sınıf`}>{kl.map(k => <option key={k.kod} value={k.kod}>{k.kod} {k.ad}</option>)}</optgroup> : null;
                })}
              </select>
              )}

              {/* Kazanım chip'i: kaskad gizliyken (0 veya 2+ ders) aktif kazanım
                  filtresi görünür kalsın — matematik rozet tıklaması (mat+geo)
                  buraya düşer; × filtreyi temizler. */}
              {!tekDers && (kazanimDetay || kazanimKonu) && (
                <span className="flex items-center gap-1 px-2 py-1 rounded border border-indigo-300 bg-indigo-50 text-xs text-indigo-700 font-semibold">
                  {maarifKazanimMi(kazanimDetay || kazanimKonu, mufredat) ? 'Öğrenme çıktısı' : 'Kazanım'}: {kazanimDetay || kazanimKonu}
                  <button onClick={() => { setKazanimKonu(''); setKazanimDetay(''); setSayfa(1); }}
                    className="text-indigo-400 hover:text-indigo-800" title={`${maarifKazanimMi(kazanimDetay || kazanimKonu, mufredat) ? 'Öğrenme çıktısı' : 'Kazanım'} filtresini kaldır`}>×</button>
                </span>
              )}

              {tekDers && kazanimKonu && kazanimHarita && (() => {
                const sk = kazanimHarita.find(k => k.kod === kazanimKonu);
                if (!sk) return null;
                return (
                  <select value={kazanimDetay} onChange={e => { setKazanimDetay(e.target.value); setSayfa(1); }}
                    aria-label={`${soz.Ad} detayı`} title={`${soz.Ad} detayı`}
                    className="px-2 py-1.5 rounded border border-indigo-300 text-xs bg-white max-w-[220px]">
                    <option value="">Tüm {sk.ad}</option>
                    {sk.alt_konular.map(ak => (
                      <optgroup key={ak.kod} label={`${ak.kod} ${ak.ad}`}>
                        <option value={ak.kod}>↳ Tümü</option>
                        {ak.kazanimlar.map(kaz => <option key={kaz.kod} value={kaz.kod}>{kaz.kod} {kaz.ad.length > 35 ? kaz.ad.substring(0, 35) + '…' : kaz.ad}</option>)}
                      </optgroup>
                    ))}
                  </select>
                );
              })()}
            </div>

            <div className="flex items-center border border-gray-300 rounded overflow-hidden bg-white">
              <span className="px-1.5 text-xs text-gray-500">#</span>
              {/* Yalniz rakam kabul edilir: kutu serbest metindi ve yazilan harf
                  oldugu gibi `?public_no=` olarak gidiyordu. Backend eskiden bunu
                  SESSIZCE yok sayip TUM havuzu donduruyordu; 2026-08-31'den beri
                  400 donuyor. Dogru yer kaynak: gecersiz deger hic uretilmesin. */}
              <input type="text" inputMode="numeric" value={publicNoAra}
                onChange={e => { setPublicNoAra(e.target.value.replace(/[^0-9]/g, '')); setSayfa(1); }}
                placeholder="Soru no" aria-label="Soru numarası" className="w-16 px-0.5 py-1.5 text-xs outline-none" />
              {publicNoAra && <button onClick={() => { setPublicNoAra(''); setSayfa(1); }} className="px-1 text-gray-400 hover:text-gray-700 text-xs">×</button>}
            </div>

            {/* GÖRÜNÜM: sıralama · Gruplu/Liste · seçim modu (listenin kendisiyle ilgili, kapsamın yanında) */}
            <div className="flex flex-wrap items-center gap-1.5">
              {/* SIRALAMA — Gruplu görünümde backend grup sırasını dayattığı için pasif. */}
              <select aria-label="Sıralama"
                      title={listeModu === 'grup' ? 'Gruplu görünümde sıralama backend grup sırasına göredir' : 'Sıralama'}
                      value={siralama} disabled={listeModu === 'grup'}
                      onChange={e => { setSiralama(e.target.value); setSayfa(1); }}
                      className="px-2 py-1.5 rounded border border-gray-300 text-xs bg-white disabled:bg-gray-100 disabled:text-gray-400">
                {SIRALAMALAR.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
              <div className="flex border border-gray-300 rounded overflow-hidden" role="group" aria-label="Liste görünümü">
                <button onClick={() => { setListeModu('kitapcik'); setSayfa(1); }} aria-pressed={listeModu === 'kitapcik'}
                  title="Soru kitapçığı sayfası görünümü — yalnız soru ve şıklar, sayfa başına 10 soru"
                  className={`px-2 py-1.5 text-xs ${listeModu === 'kitapcik' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>📖 Kitapçık</button>
                <button onClick={() => { setListeModu('grup'); setSayfa(1); }} aria-pressed={listeModu === 'grup'}
                  className={`px-2 py-1.5 text-xs ${listeModu === 'grup' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>Gruplu</button>
                <button onClick={() => { setListeModu('duz'); setSayfa(1); }} aria-pressed={listeModu === 'duz'}
                  className={`px-2 py-1.5 text-xs ${listeModu === 'duz' ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>Liste</button>
              </div>
              {/* Çoklu seçim aç/kapa (2026-09-13) — kartlardaki checkbox'ları ve seçim
                  çubuğunu devreye sokar. SEÇİM = BASIM LİSTESİ (2026-09-14, kullanıcı:
                  "seçilenleri temizle = basım listesine alma"); çubuk soruların
                  DURUMUNU değiştirmez. */}
              <button onClick={() => { setTopluMod(v => !v); setSeciliIds(new Set()); }}
                title="Soru kartlarında basım için seçim kutucuklarını aç/kapat"
                className={`px-2 py-1.5 rounded text-xs border ${topluMod ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>
                {topluMod ? '☑ Seçim modu' : '☐ Seç'}
              </button>
            </div>

            {/* SAYFA GEÇİŞLERİ */}
            <nav className="ml-auto flex flex-wrap items-center gap-1.5" aria-label="Sayfalar">
              {rolYeterli('admin') && <button onClick={() => { setBasimOnSecim(null); setGorunum('basim'); }} className={NAV_DUGME}>🖨 Basım</button>}
              {rolYeterli('super_admin') && <button onClick={() => setGorunum('uretim')} title="Üretim otomasyonu: routine'leri çalıştır, aç/kapat, duraklat — yalnız süperadmin" className="px-2.5 py-1.5 rounded-md border border-blue-600 bg-blue-600 text-xs font-semibold text-white hover:bg-blue-700">▶ Üret</button>}
              {rolYeterli('admin') && <button onClick={() => { setSatisBaslangicSekme('aktif'); setGorunum('satis'); }} className={NAV_DUGME}>💰 Satış</button>}
              {rolYeterli('super_admin') && <button onClick={() => setGorunum('uzmanSet')} className={NAV_DUGME} title="2027 TYT Problemler uzman seti — yalnız süperadmin">🎓 Uzman Seti</button>}
              {rolYeterli('admin') && <button onClick={() => setGorunum('musteriSiparis')} className={NAV_DUGME} title="Müşteri hesaplarının siparişleri: satışa işle, iptal, Basım'a gönder">🧾 Siparişler</button>}
              {rolYeterli('admin') && <button onClick={() => setGorunum('kullanicilar')} className={NAV_DUGME}>👤 Kullanıcılar</button>}
            </nav>
          </div>

          {/* SÜZGEÇLER — tek tip açılır kutular. */}
          <div className="flex flex-wrap items-center gap-1.5 rounded-b-xl border-t border-gray-100 bg-gray-50/70 px-3 py-2">
            <span className="mr-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400">Süzgeç</span>
            <SuzgecSecimleri degerler={suzgecDegerleri} onDegis={suzgecDegis} />
            <span className="mx-0.5 hidden h-5 w-px bg-gray-200 sm:block" aria-hidden="true" />
            {/* SATIŞ SÜZGECİ (2026-09-14): satış münhasır — yayınevine gidecek yeni
                seçimde "Satılmamış"; satılanlar "💰" rozetiyle listede kalır. */}
            <select aria-label="Satış durumu" title="Satış durumu: yayınevine satılan sorular" value={satisFiltre}
                    onChange={e => { setSatisFiltre(e.target.value); setSayfa(1); }}
                    className={suzgecSinifi(satisFiltre, 'border-emerald-400 bg-emerald-50 text-emerald-800 font-semibold')}>
              <option value="">💰 Satış: tümü</option>
              <option value="satilmamis">Satılmamış</option>
              <option value="satilan">💰 Satılanlar</option>
            </select>
            {satisFiltre === 'satilan' && rolYeterli('admin') && (
              <YayineviSecici apiUrl={API} authFetch={authFetch}
                value={satisYayinevi ? satisYayinevi.id : null} valueAd={satisYayinevi ? satisYayinevi.ad : ''}
                onChange={(y) => { setSatisYayinevi(y && y.id != null ? { id: y.id, ad: y.ad } : null); setSayfa(1); }}
                etiket="" bosSecenek="Tüm yayınevleri" allowInactive yeniEkle={false} className="w-48" />
            )}
            {(dersler.length > 0 || kazanimKonu || kazanimDetay || mufredat || publicNoAra || puanFiltre || pratikDurum || baglamFiltre || gorselFiltre || satisFiltre || qcFiltre || korPuanFiltre || komsuFiltre) && (
              <button onClick={filtreleriSifirla} title={`Ders, ${soz.ad}, soru no ve tüm süzgeçleri temizler`}
                className="ml-1 px-2 py-1.5 rounded text-xs text-gray-500 hover:bg-gray-200 hover:text-gray-800">× Tümünü sıfırla</button>
            )}
          </div>
          </div>

          {/* SEÇİM ÇUBUĞU = BASIM LİSTESİ (2026-09-14, kullanıcı kararı). Toplu
              onay/red düğmeleri KALDIRILDI: hiç istenmemişti; 09-13'te "☐ Seç"
              eklenince eski ölü kod görünür oldu ve #1 yanlışlıkla reddedildi
              (denetim #91465). Çubuk hiçbir sorunun DURUMUNU değiştirmez. */}
          {topluMod && seciliIds.size > 0 && (
            <div className="flex gap-3 items-center p-3 bg-blue-50 rounded-lg mb-3 text-sm">
              <span className="font-semibold">{seciliIds.size} soru seçildi</span>
              {rolYeterli('admin') && (
                <button data-secim-cubugu="basim" onClick={() => { setBasimOnSecim(null); setGorunum('basim'); }}
                  title="Seçili soruları Basım ekranına 'Seçili sorular' olarak götürür"
                  className="px-4 py-1 rounded bg-orange-600 text-white font-semibold text-xs hover:bg-orange-700">
                  🖨 Basım listesine al ({seciliIds.size})
                </button>
              )}
              <button data-secim-cubugu="temizle" onClick={() => setSeciliIds(new Set())}
                title="Seçimi boşaltır — sorular basım listesine alınmaz, hiçbir sorunun durumu değişmez"
                className="px-4 py-1 rounded border border-gray-400 bg-white text-gray-700 font-semibold text-xs hover:bg-gray-50">
                ✗ Seçilenleri temizle
              </button>
              {rolYeterli('admin') && (
                <button onClick={topluSatisaEkle}
                  title="Yalnız satışa uygun (onaylı, satılmamış, hatalı işaretlenmemiş) seçili sorular satış kaydına girer"
                  className="px-4 py-1 rounded bg-emerald-600 text-white font-semibold text-xs">💰 Satışa Ekle</button>
              )}
            </div>
          )}

          {/* İÇERİK */}
          {yukleniyor ? (
            <SkeletonGrid />
          ) : sorular.length === 0 ? (
            <BosDurum onSifirla={filtreleriSifirla} />
          ) : listeModu === 'grup' && gruplar ? (
            /* ===== GRUPLU GÖRÜNÜM ===== */
            <div className="space-y-4">
              {Object.entries(gruplar).map(([dersKey, konular]) => {
                const dersAcik = acikGruplar.has(dersKey);
                const dersSorular = Object.values(konular).flat();
                const dersLabel = DERSLER.find(d => d.value === dersKey)?.label || dersKey.replace('_', ' ');

                return (
                  <div key={dersKey} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                    {/* DERS BAŞLIĞI */}
                    <button onClick={() => grupToggle(dersKey)}
                      className="w-full flex items-center justify-between px-5 py-3 hover:bg-gray-50 transition-colors">
                      <div className="flex items-center gap-3">
                        <span className="text-lg">{dersAcik ? '▼' : '►'}</span>
                        <span className="text-white px-3 py-1 rounded-lg text-sm font-bold" style={{backgroundColor: dersRenk(dersKey)}}>{dersLabel}</span>
                        <span className="text-gray-400 text-sm">{dersSorular.length} soru</span>
                      </div>
                      <div className="flex gap-1">
                        {['kolay','orta','zor','uzman'].map(z => {
                          const count = dersSorular.filter(s => s.zorluk === z).length;
                          return count > 0 ? <span key={z} className="text-white px-2 py-0.5 rounded text-[10px] font-semibold" style={{backgroundColor: zorlukRenk(z)}}>{count}</span> : null;
                        })}
                      </div>
                    </button>

                    {/* KONU GRUPLARI */}
                    {dersAcik && (
                      <div className="px-4 pb-3 space-y-3">
                        {Object.entries(konular).map(([konuKey, konuSorulari]) => {
                          const konuAcik = acikGruplar.has(`${dersKey}|${konuKey}`);
                          return (
                            <div key={konuKey} className="border border-gray-100 rounded-lg overflow-hidden">
                              {/* KONU BAŞLIĞI */}
                              <button onClick={() => grupToggle(`${dersKey}|${konuKey}`)}
                                className="w-full flex items-center justify-between px-4 py-2 bg-gray-50 hover:bg-gray-100 transition-colors">
                                <div className="flex items-center gap-2">
                                  <span className="text-sm text-gray-500">{konuAcik ? '▾' : '▸'}</span>
                                  <span className="text-sm font-semibold text-gray-700">{konuKey}</span>
                                  {/* Maarif'te grup anahtari alt_konu — ogrenme alani adini
                                      kaybetmemek icin kucuk gri ek olarak goster. */}
                                  {konuSorulari[0]?.konu && konuSorulari[0].konu !== konuKey && (
                                    <span className="text-[10px] text-gray-400">· {konuSorulari[0].konu}</span>
                                  )}
                                  <span className="text-xs text-gray-400">({konuSorulari.length})</span>
                                </div>
                                <div className="flex gap-1">
                                  {['kolay','orta','zor','uzman'].map(z => {
                                    const c = konuSorulari.filter(s => s.zorluk === z).length;
                                    return c > 0 ? <span key={z} className="text-[9px] px-1.5 py-0.5 rounded font-bold" style={{backgroundColor: zorlukRenk(z), color:'#fff'}}>{z[0].toUpperCase()}{c}</span> : null;
                                  })}
                                </div>
                              </button>

                              {/* SORULAR */}
                              {konuAcik && (
                                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-2 p-3">
                                  {baglamGrupla(konuSorulari).map(s => renderKart(s))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : listeModu === 'kitapcik' ? (
            /* ===== KİTAPÇIK GÖRÜNÜMÜ ===== */
            <>
              <Sayfalama sayfa={sayfa} toplamSayfa={toplamSayfa} sayfaGit={sayfaGit} />
              <div className="mt-4">
                <KitapcikGorunum ogeler={baglamGrupla(sorular)} ilkNo={(sayfa - 1) * KITAPCIK_LIMIT + 1}
                  onSoruTikla={(s) => soruDetayGetir(s.id)} onGrupTikla={grupKartTikla}
                  rozetler={kitapRozetleri} grupRozetleri={kitapGrupRozetleri}
                  seciliIds={seciliIds} topluMod={topluMod} />
              </div>
            </>
          ) : (
            /* ===== DÜZ LİSTE ===== */
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3">
              {baglamGrupla(sorular).map(s => renderKart(s))}
            </div>
          )}

          <Sayfalama sayfa={sayfa} toplamSayfa={toplamSayfa} sayfaGit={sayfaGit} />
        </>
      ) : gorunum === 'detay' && seciliSoru ? (
        // Bağlam temelli grup (KURALLAR §19.3): üyeler tek birleşik kartta;
        // grupsuz soruda eski tekil görünüm AYNEN.
        grupDetay ? (
          <BaglamGrupKarti grup={grupDetay} onOnayla={soruOnayla} onPuanKaydet={puanKaydet} onPratikOnayla={soruPratikOnay} onVideoOnayla={soruVideoOnay} onKorCevap={korCevap} onKorPuan={korPuanVer} onCevapQcKanit={cevapQcKanit} onCevapQcIstek={rolYeterli('admin') ? cevapQcIstek : undefined} onGeri={detaydanCik} />
        ) : (
        <SoruKarti soru={seciliSoru} onOnayla={soruOnayla} onPuanKaydet={puanKaydet} onPratikOnayla={soruPratikOnay} onVideoOnayla={soruVideoOnay} onKorCevap={korCevap} onKorPuan={korPuanVer} onCevapQcKanit={cevapQcKanit} onCevapQcIstek={rolYeterli('admin') ? cevapQcIstek : undefined} onGeri={detaydanCik} />
        )
      ) : gorunum === 'basim' ? (
        // baslangicSeciliIds: listede toplu-seçilen sorular Basım'a taşınır.
        // 2026-08-13 öncesi bu prop hiç geçilmiyordu; Basim onu bekliyor
        // (default []) ve kaynak modunu ona göre seçiyordu — kullanıcı listede
        // seçtiği soruları Basım içinde yeniden aramak zorunda kalıyordu.
        // basimOnSecim (2026-09-14): Satış Arşivi'nden gelen onaylı sorular öncelikli;
        // "Çözümler PDF’in sonunda" açık başlar, Geri Satış ekranına döner.
        // 2026-09-15: yayınevi DB listesi — authFetch (YayineviSecici), ön-seçili yayınevi,
        // "Satış Arşivi’nde gör" → Satış ekranı ilgili sekmeyle.
        <Basim apiUrl={API} authFetch={authFetch}
          baslangicSeciliIds={basimOnSecim ? basimOnSecim.ids : [...seciliIds]}
          varsayilanCozumAyri={!!basimOnSecim}
          baslangicYayineviId={basimOnSecim ? (basimOnSecim.yayineviId ?? null) : null}
          baslangicYayineviAd={basimOnSecim ? (basimOnSecim.yayineviAd || '') : ''}
          onSatisArsivineGit={(sekme) => { setBasimOnSecim(null); setSatisBaslangicSekme(sekme || 'aktif'); setGorunum('satis'); }}
          onGeri={() => { const d = basimOnSecim && basimOnSecim.donus; setBasimOnSecim(null); setGorunum(d || 'liste'); }} />
      ) : gorunum === 'uretim' ? (
        <Uretim apiUrl={API} authFetch={authFetch} onGeri={() => { setGorunum('liste'); sorulariGetir(); }} />
      ) : gorunum === 'kullanicilar' ? (
        <Kullanicilar apiUrl={API} authFetch={authFetch} rolYeterli={rolYeterli} onGeri={() => setGorunum('liste')} />
      ) : gorunum === 'musteriSiparis' && rolYeterli('admin') ? (
        <MusteriSiparisYonetimi apiUrl={API} authFetch={authFetch} onGeri={() => setGorunum('liste')}
          onBasimaGonder={({ ids, yayineviId, yayineviAd }) => {
            setBasimOnSecim({ ids, yayineviId: yayineviId ?? null, yayineviAd: yayineviAd || '', donus: 'musteriSiparis' });
            setGorunum('basim');
          }} />
      ) : gorunum === 'satis' ? (
        <SoruSatisi apiUrl={API} authFetch={authFetch} rolYeterli={rolYeterli} onGeri={() => setGorunum('liste')}
          baslangicSekme={satisBaslangicSekme}
          onBasimaGonder={({ ids, yayineviId, yayineviAd }) => {
            setBasimOnSecim({ ids, yayineviId: yayineviId ?? null, yayineviAd: yayineviAd || '', donus: 'satis' });
            setGorunum('basim');
          }} />
      ) : gorunum === 'paketler' ? (
        <PaketInceleme apiUrl={API} onGeri={() => setGorunum('liste')} onSoruSec={async (id) => { const r = await authFetch(`${API}/api/sorular/${id}`); const so = await r.json(); setSeciliSoru(so); setGrupDetay(null); setGorunum('detay'); if (so && so.kaynak_detay && so.kaynak_detay.baglam_grubu) await grupGetir(id); }} />
      ) : gorunum === 'uzmanSet' && rolYeterli('super_admin') ? (
        <UzmanSeti apiUrl={API} authFetch={authFetch} onGeri={() => setGorunum('liste')}
          onBasimaGonder={(ids) => { setBasimOnSecim({ ids, yayineviId: null, yayineviAd: '', donus: 'uzmanSet' }); setGorunum('basim'); }}
          onSoruSec={async (id) => { const r = await authFetch(`${API}/api/sorular/${id}`); if (!r.ok) { toastGoster('Soru açılamadı: ' + r.status, 'hata'); return; } const so = await r.json(); setSeciliSoru(so); setGrupDetay(null); setDetayDonus('uzmanSet'); setGorunum('detay'); }} />
      ) : gorunum === 'denemeler' ? (
        <DenemeInceleme apiUrl={API} onGeri={() => setGorunum('liste')} onSoruSec={async (id) => { const r = await authFetch(`${API}/api/sorular/${id}`); const so = await r.json(); setSeciliSoru(so); setGrupDetay(null); setGorunum('detay'); if (so && so.kaynak_detay && so.kaynak_detay.baglam_grubu) await grupGetir(id); }} />
      ) : gorunum === 'test' && testPartisi ? (
        <TestGorunum
          apiUrl={API}
          partisi={testPartisi}
          baslik={testPartisi === '2026_tyt_mat_parti2'
            ? 'EBOB-EKOK Test — 5 Soru (K3/K4)'
            : '2026 TYT Matematik — 10 Soru'}
          authFetch={authFetch}
          onGeri={() => setGorunum('liste')}
        />
      ) : null}
      {satisModal && (satisModal.nolar.length > 0 || satisModal.elenenler.length > 0) && (
        <SatisEkleModal apiUrl={API} authFetch={authFetch} publicNolar={satisModal.nolar}
          elenenler={satisModal.elenenler} seciliSayisi={satisModal.seciliSayisi}
          qcUyusmazlik={satisModal.qcUyusmazlik || []}
          onKapat={() => setSatisModal(null)}
          onTamam={(d) => { setSatisModal(null); setSeciliIds(new Set()); toastGoster(satisOzeti(d)); sorulariGetir(); }} />
      )}
    </div>
  );
}

// Yükleme iskeleti — kart-biçimli gri placeholder ızgarası.
function SkeletonGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3" aria-busy="true" aria-label="Yükleniyor">
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 animate-pulse">
          <div className="flex justify-between mb-2">
            <div className="h-4 w-16 bg-gray-200 rounded" />
            <div className="h-4 w-12 bg-gray-200 rounded" />
          </div>
          <div className="h-4 w-3/4 bg-gray-200 rounded mb-2" />
          <div className="flex gap-1 mb-2">
            <div className="h-3 w-14 bg-gray-100 rounded" />
            <div className="h-3 w-10 bg-gray-100 rounded" />
          </div>
          <div className="h-3 w-1/2 bg-gray-100 rounded" />
        </div>
      ))}
    </div>
  );
}

// Boş-sonuç durumu — dostça mesaj + filtre sıfırlama.
function BosDurum({ onSifirla }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="text-5xl mb-3 opacity-60">🔍</div>
      <div className="text-gray-700 font-semibold mb-1">Sonuç bulunamadı</div>
      <div className="text-gray-400 text-sm mb-4">Seçili filtrelerle eşleşen soru yok.</div>
      <button onClick={onSifirla}
        className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700">
        Filtreleri sıfırla
      </button>
    </div>
  );
}

// dersRenk: ./lib/dersler'den import edilir (tek doğruluk kaynağı).
function zorlukRenk(z) { return { kolay: '#4CAF50', orta: '#FF9800', zor: '#F44336', uzman: '#9C27B0' }[z] || '#757575'; }
function durumRenk(d) { return { uretildi: '#2196F3', judge_gecti: '#FF9800', duplicate_kontrol_edildi: '#8BC34A', onaylandi: '#4CAF50', reddedildi: '#F44336', onay_bekliyor: '#FFC107' }[d] || '#9E9E9E'; }
function durumEtiket(d) { return { uretildi: 'Üretildi', judge_gecti: 'Değerlendirildi', duplicate_kontrol_edildi: 'Doğrulandı', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi', onay_bekliyor: 'Onay Bekliyor', sympy_dogrulandi: 'SymPy OK' }[d] || d; }
